(function () {
  /* v17 (2026-08-31): STEPPED FLOW — mobile-only 4-step reskin (Customize →
     Quantity → Payment → Review) over the unchanged engine. Phase A shipped
     the inert gate; Phase B mounts the step panels (quantity typed entry +
     tier narration, payment with NO preselection, review money block +
     Continue to Checkout via handleSubmit). Inactive unless the gate passes
     (mobile width + backpack design + stepped_flow config or ?flow=stepped);
     the flat bar stays in the DOM as the rollback presentation.
     Plan: docs/orbit-stepped-flow-plan.md · prototype: docs/orbit-flow-prototype.html */
  /* v4 (2026-06-23): gate extended to the Elemental Jacket (210147750).
     v5 (2026-06-23): volume-table footer shows the real per-unit logo charge
     when logoIncludedFree is false (the jacket's $5/qty logo), instead of the
     hardcoded "Logo included free".
     v6 (2026-06-23): size-run grid (SIZE_MODE) — replaces the single quantity
     stepper with a per-size grid (Adult Men's/Women's toggle + unisex Youth)
     that writes KitBuilder's teamdetails.sizes via the bridge's syncSizes and
     carries the breakdown to the cart line. See setupSizeStep() at the foot.
     v7 (2026-06-23): two-step flow — Step 1 design (bar shows "Continue to add
     sizes"), Step 2 a full overlay sheet for the size grid + Add to cart.
     v8 (2026-06-23): at Add to cart, offer the matching joggers — Yes stashes a
     logo-carry flag + sets the post-add redirect to the joggers customizer, then
     submits the jacket; No submits normally. See showJoggersPrompt(). */
  /* v13 (2026-06-23): gate via the auto-coach engine's shared check so the panel
     runs on any static coach design OR any auto-detected tracksuit colorway. */
  /* v14 (2026-07-03): size-run carry-over — when a sized design is submitted,
     its label→qty breakdown is stashed; when the coach then opens the PAIRED
     design's size sheet (jacket → joggers or vice versa), a prompt offers to
     use the same sizes. Yes prefills the grid (label-keyed, since KB size ids
     differ per design); No leaves manual entry exactly as before. See
     stashSizesForPair()/maybeOfferCarriedSizes(). */
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || !(window.__xeistCoachOn && window.__xeistCoachOn())) return;

  var root = document.querySelector('[data-xeist-coach-order-panel]');
  if (!root) return;

  /* Safe storage (batch-2 hardening, 2026-07-04). Accessing
     window.localStorage throws SecurityError when cookies are fully blocked;
     setItem throws in Safari private mode / over quota. Every storage touch
     goes through these, falling back to an in-memory map so a blocked store
     degrades features to per-pageview behavior instead of killing the panel. */
  /* v16 (2026-07-04): FIX batch-2 regression — lsGet/lsSet recursed into
     THEMSELVES instead of touching window.localStorage, so every call blew
     the stack (RangeError, caught by the deepest frame's try) and fell
     through to the in-memory map. Result: deposit prefs, size-carry
     (xeist_carry_sizes) and xeist_set_added silently stopped persisting
     across pageviews. Now actually hit localStorage; the memory fallback
     fires only on real storage errors, as intended. */
  var __memStore = {};
  function lsGet(k) {
    try { return window.localStorage.getItem(k); }
    catch (e) { return Object.prototype.hasOwnProperty.call(__memStore, k) ? __memStore[k] : null; }
  }
  function lsSet(k, v) {
    try { window.localStorage.setItem(k, String(v)); }
    catch (e) { __memStore[k] = String(v); }
  }

  var config = window.XeistOrbitCoachConfig || {};
  var productSlug = String(config.productSlug || root.getAttribute('data-product-slug') || '').toLowerCase();
  if (!productSlug) return;

  var rules = config.rules || {};
  var pricing = config.pricing || {};
  var minQty = Math.max(1, toInt(rules.minQty, 1));
  var maxQty = Math.max(minQty, toInt(rules.maxQty, 500));

  /* Per-design product noun (2026-06-23). The panel is a single shared
     instance reused across designs; the backpacks leave these unset and keep
     the original "bag"/"bags" copy, while the Elemental Jacket sets
     "jacket"/"jackets" so every quantity/price string reads correctly. */
  var NOUN = String(config.productNoun || 'bag');
  var NOUN_PLURAL = String(config.productNounPlural || 'bags');
  function nounFor(count) { return count === 1 ? NOUN : NOUN_PLURAL; }

  /* One-time copy swaps driven by config: the panel order title and the
     bottom-bar "Cost per <noun>" kicker. Only applied when the config provides
     them, so the backpacks are untouched. */
  (function applyConfigCopy() {
    try {
      if (config.orderTitle) {
        var titleEl = document.querySelector('[data-coach-order-title]');
        if (titleEl) titleEl.textContent = config.orderTitle;
      }
      if (config.productNoun) {
        var kickerEl = document.querySelector('[data-bottom-bar-cost-kicker]');
        if (kickerEl) kickerEl.textContent = 'Cost per ' + NOUN;
      }
    } catch (e) { /* noop */ }
  })();

  /* Size-run mode (2026-06-23, the Elemental Jacket): the quantity comes from a
     per-size grid instead of the single stepper. sizeMap (KB sizeId -> qty) and
     sizeBreakdown (readable string) are kept current by the grid module at the
     foot of this file and flushed to the bridge by queueBridgeSync(). */
  var SIZE_MODE = !!(config.sizeEntry && config.sizeEntry.enabled);
  var sizeMap = {};
  var sizeBreakdown = null;

  var bridge = null;
  var bridgeToken = null;
  var bridgePoll = null;
  var mountPoll = null;
  var syncTimer = null;
  var syncChain = Promise.resolve();
  var syncRequestId = 0;
  var previewKickDone = false;

  var state = {
    bridgeReady: false,
    panelMounted: false,
    quantity: minQty,
    context: null,
    validation: null,
    hasUnsyncedChanges: false,
    hasAttemptedSubmit: false,
    isSyncing: false,
    isSubmitting: false,
    syncError: null,
    statusText: 'Loading KitBuilder',
    statusTone: 'warning',
    hydratedFromContext: false,
    lastSyncedDraftHash: '',
    uploadMessage: ''
  };

  var els = {
    state: root.querySelector('[data-coach-panel-state]'),
    unitPrice: root.querySelector('[data-coach-unit-price]'),
    subtotal: root.querySelector('[data-coach-subtotal]'),
    nextTier: root.querySelector('[data-coach-next-tier]'),
    uploadLogo: root.querySelector('[data-coach-upload-logo]'),
    logoChip: root.querySelector('[data-coach-logo-chip]'),
    qtyDown: root.querySelector('[data-coach-qty-down]'),
    qtyInput: root.querySelector('[data-coach-qty-input]'),
    qtyUp: root.querySelector('[data-coach-qty-up]'),
    qtyDisplay: root.querySelector('[data-coach-qty-display]'),
    validation: root.querySelector('[data-coach-validation]'),
    validationList: root.querySelector('[data-coach-validation-list]'),
    cta: root.querySelector('[data-coach-cta]'),
    syncNote: root.querySelector('[data-coach-sync-note]'),
    bottomBarUnitPrice: document.querySelector('[data-bottom-bar-unit-price]'),
    bottomBarSubtotal: document.querySelector('[data-bottom-bar-subtotal]'),
    bottomBarQtyDown: document.querySelector('[data-bottom-bar-qty-down]'),
    bottomBarQtyInput: document.querySelector('[data-bottom-bar-qty-input]'),
    bottomBarQtyUp: document.querySelector('[data-bottom-bar-qty-up]'),
    bottomBarCta: document.querySelector('[data-bottom-bar-cta]'),
    bottomBarNote: document.querySelector('[data-bottom-bar-note]'),
    bottomBarFeeNote: document.querySelector('[data-bottom-bar-fee-note]'),
    payModeFull: document.querySelector('[data-pay-mode-full]'),
    payModeDeposit: document.querySelector('[data-pay-mode-deposit]'),
    depositHint: document.querySelector('[data-deposit-hint]'),
    bottomBarSubNote: document.querySelector('[data-bottom-bar-sub-note]'),
    tierNudge: document.querySelector('[data-tier-nudge]'),
    tierNudgeText: document.querySelector('[data-tier-nudge-text]'),
    volumeTable: document.querySelector('[data-volume-pricing-table]')
  };

  /* Deposit preference survives reloads; the *_at_cart flag is the message
     to xeist-deposit-cart-apply.js on the cart page after the KB handoff. */
  var DEPOSIT_PREF_KEY = 'xeist_deposit_pref';
  var DEPOSIT_APPLY_KEY = 'xeist_apply_deposit_at_cart';
  try {
    state.depositSelected = lsGet(DEPOSIT_PREF_KEY) === '1';
  } catch (e) {
    state.depositSelected = false;
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : fallback;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return isFinite(parsed) ? parsed : fallback;
  }

  function safeClone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) {
      return '[' + value.map(stableStringify).join(',') + ']';
    }

    var keys = Object.keys(value).sort();
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      parts.push(JSON.stringify(keys[i]) + ':' + stableStringify(value[keys[i]]));
    }
    return '{' + parts.join(',') + '}';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
      }).format(value || 0);
    } catch (error) {
      return '$' + toNumber(value, 0).toFixed(2);
    }
  }

  function normalizeQuantity(value) {
    return Math.min(maxQty, Math.max(minQty, toInt(value, minQty)));
  }

  /* Clamp for display/pricing without silently snapping up to minQty.
     Below-minimum quantities stay visible so we can show "Add X more to
     meet the minimum" instead of rewriting what the customer typed. */
  function clampQty(value, fallback) {
    var parsed = toInt(value, NaN);
    if (!isFinite(parsed)) parsed = fallback;
    return Math.min(maxQty, Math.max(1, parsed));
  }


  function getDraftHash() {
    return stableStringify({
      quantity: state.quantity
    });
  }

  function getConfiguredTiers() {
    var tiers = Array.isArray(pricing.baseTiers) ? pricing.baseTiers.slice() : [];
    var normalized = [];

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i] || {};
      var min = toInt(tier.min, null);
      if (min === null) continue;

      normalized.push({
        min: min,
        max: tier.max === null || typeof tier.max === 'undefined' ? null : toInt(tier.max, null),
        unitPrice: toNumber(tier.unitPrice, 0)
      });
    }

    normalized.sort(function (left, right) {
      return left.min - right.min;
    });

    return normalized;
  }

  function getTierForQuantity(quantity) {
    var tiers = getConfiguredTiers();
    var current = tiers[0] || { min: minQty, max: null, unitPrice: 0 };

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var matchesMin = quantity >= tier.min;
      var matchesMax = tier.max === null || quantity <= tier.max;
      if (matchesMin && matchesMax) {
        current = tier;
        break;
      }
      if (quantity >= tier.min) current = tier;
    }

    return current;
  }

  /* Volume pricing accordion rows — same tier config + FX as the page
     prices, so the table can never disagree with the bar. */
  function renderVolumeTable(summary) {
    var tiers = getConfiguredTiers();
    if (!tiers.length) return;
    var html = '';
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var label = tier.max === null ? tier.min + '+ ' + NOUN_PLURAL : tier.min + '\u2013' + tier.max + ' ' + NOUN_PLURAL;
      var active = summary.quantity >= tier.min && (tier.max === null || summary.quantity <= tier.max);
      var price = formatMoney(tier.unitPrice * summary.fx);
      html += '<div class="xeist-volume-pricing__row' + (active ? ' is-active' : '') + '">'
        + '<span>' + label + '</span><span>' + price + ' / ' + NOUN + '</span></div>';
    }
    var logoFree = !(pricing && pricing.logoIncludedFree === false);
    var footLogo = logoFree
      ? 'Logo included free'
      : 'Logo +' + formatMoney(toNumber(pricing.logoUpcharge, 0) * summary.fx) + ' / ' + NOUN;
    html += '<p class="xeist-volume-pricing__foot">' + footLogo + ' \u00b7 discounts apply automatically</p>';
    if (els.volumeTable.__xeistHtml !== html) {
      els.volumeTable.innerHTML = html;
      els.volumeTable.__xeistHtml = html;
    }
  }

  function getNextTier(quantity) {
    var tiers = getConfiguredTiers();
    var currentTier = getTierForQuantity(quantity);
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].min <= quantity) continue;
      if (tiers[i].unitPrice < currentTier.unitPrice) return tiers[i];
    }
    return null;
  }

  function hasNumberSelection() {
    /* Prefer bridge if available */
    var b = window.XeistKBBridge;
    if (b && typeof b.hasNumber === 'function') {
      var ns = b.hasNumber();
      return ns && ns.hasNumber;
    }
    /* Fallback: check editor items */
    var ctx = state.context || {};
    var kit = ctx.kit || (b && b.getContext && b.getContext().kit) || null;
    if (!kit || !Array.isArray(kit.editor)) return false;
    var numberKeys = (config.numberPlacementKeys || ['add-number', 'number']);
    for (var i = 0; i < kit.editor.length; i++) {
      if (kit.editor[i].type !== 'text') continue;
      var pk = String(kit.editor[i].placementKey || '').toLowerCase();
      for (var j = 0; j < numberKeys.length; j++) {
        if (pk === numberKeys[j].toLowerCase()) return true;
      }
    }
    return false;
  }

  function hasLogoSelectionLocal() {
    var b = window.XeistKBBridge;
    if (b && typeof b.hasLogo === 'function') {
      var ls = b.hasLogo();
      return ls && ls.hasLogo;
    }
    var context = state.context || {};
    return !!context.logoSelected;
  }

  /* The store's BASE currency is USD (KitBuilder prices are USD); Shopify
     Markets presents/charges CAD at a floating rate exposed on
     window.Shopify.currency.rate. Mirroring that conversion here — including
     Markets' whole-dollar rounding of the converted line total — keeps the
     displayed price identical to the charged price at any exchange rate. */
  function presentmentRate() {
    try {
      var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      if (isFinite(r) && r > 0) return r;
    } catch (e) { /* noop */ }
    return 1;
  }

  function getSummary() {
    var quantity = clampQty(state.quantity, minQty);
    var tier = getTierForQuantity(quantity);
    var unitPriceUsd = toNumber(tier.unitPrice, 0);

    if (hasLogoSelectionLocal()) {
      unitPriceUsd += toNumber(pricing.logoUpcharge, 0);
    }

    if (hasNumberSelection()) {
      unitPriceUsd += toNumber(pricing.numberUpcharge, 0);
    }

    var fx = presentmentRate();
    var subtotal = unitPriceUsd * quantity * fx;
    /* Shopify Markets rounds the converted line price to the whole dollar —
       match it so the cart total is what the customer already saw. */
    if (fx !== 1) subtotal = Math.round(subtotal);
    var unitPrice = quantity > 0 ? subtotal / quantity : 0;

    var nextTier = getNextTier(quantity);
    var remaining = nextTier ? Math.max(0, nextTier.min - quantity) : 0;

    return {
      quantity: quantity,
      unitPrice: unitPrice,
      unitPriceUsd: unitPriceUsd,
      fx: fx,
      subtotal: subtotal,
      nextTier: nextTier,
      remaining: remaining
    };
  }


  function syncLocalFromContext(snapshot) {
    var snapQty = toInt(snapshot.quantity, minQty);
    state.quantity = normalizeQuantity(snapshot.quantity || minQty);
    state.validation = snapshot.validation || null;
    state.syncError = null;
    state.hydratedFromContext = true;
    state.lastSyncedDraftHash = getDraftHash();
    state.hasUnsyncedChanges = false;

    /* Saved drafts created before the minimum-order rule may carry a
       below-minimum quantity (e.g. 1). We display the clamped minimum, so
       push it back to KitBuilder to keep both sides honest. */
    if (isFinite(snapQty) && snapQty < minQty) {
      state.hasUnsyncedChanges = true;
      scheduleSync(200);
    }
  }

  function buildMessages() {
    var localValidation = getLocalValidation();

    if (!state.bridgeReady) {
      return {
        tone: 'warning',
        items: ['KitBuilder is still loading for ' + (config.orderTitle ? config.orderTitle.replace(/ Order$/, '') : 'your product') + '.']
      };
    }

    if (state.isSubmitting) {
      return {
        tone: 'warning',
        items: ['Submitting through KitBuilder. Please wait.']
      };
    }

    if (state.isSyncing && state.hasAttemptedSubmit) {
      return {
        tone: 'warning',
        items: ['Syncing your coach order with KitBuilder.']
      };
    }

    if (state.hasUnsyncedChanges && state.hasAttemptedSubmit) {
      return {
        tone: 'warning',
        items: ['Changes are pending sync.']
      };
    }

    if (state.syncError) {
      return {
        tone: 'error',
        items: [state.syncError]
      };
    }

    if (!state.hasAttemptedSubmit) {
      return {
        tone: 'ready',
        items: []
      };
    }

    if (!localValidation.valid) {
      return {
        tone: 'error',
        items: localValidation.reasons
      };
    }

    if (state.validation && !state.validation.valid) {
      return {
        tone: 'error',
        items: (state.validation.reasons || []).map(function (reason) {
          return reason.message;
        })
      };
    }

    return {
      tone: 'ready',
      items: []
    };
  }

  function getLocalValidation() {
    var reasons = [];
    var quantity = clampQty(state.quantity, minQty);

    if (quantity < minQty) {
      var needed = minQty - quantity;
      reasons.push('Add ' + needed + ' more ' + nounFor(needed) + ' to meet the ' + minQty + '-' + NOUN + ' minimum.');
    }

    return {
      valid: reasons.length === 0,
      reasons: reasons
    };
  }

  function updateStatusBadge(messages) {
    if (!els.state) return;

    if (!state.bridgeReady) {
      els.state.textContent = 'Loading';
      els.state.setAttribute('data-tone', 'warning');
      return;
    }

    if (state.isSubmitting) {
      els.state.textContent = 'Submitting';
      els.state.setAttribute('data-tone', 'syncing');
      return;
    }

    if (state.isSyncing || state.hasUnsyncedChanges) {
      els.state.textContent = 'Syncing';
      els.state.setAttribute('data-tone', 'syncing');
      return;
    }

    if (!state.hasAttemptedSubmit) {
      els.state.textContent = 'Draft';
      els.state.removeAttribute('data-tone');
      return;
    }

    if (messages.items.length) {
      els.state.textContent = 'Needs attention';
      els.state.setAttribute('data-tone', messages.tone);
      return;
    }

    els.state.textContent = 'Ready';
    els.state.setAttribute('data-tone', 'ready');
  }


  function renderValidation(messages) {
    if (!els.validation || !els.validationList) return;

    if (!messages.items.length) {
      els.validation.hidden = true;
      els.validationList.innerHTML = '';
      return;
    }

    els.validation.hidden = false;
    els.validation.setAttribute('data-tone', messages.tone);
    els.validationList.innerHTML = messages.items.map(function (message) {
      return '<li>' + escapeHtml(message) + '</li>';
    }).join('');
  }

  function render() {
    var summary = getSummary();
    var messages = buildMessages();
    var localValidation = getLocalValidation();
    var bridgeValid = !!(state.validation && state.validation.valid);
    /* CTA availability is about whether a submit can be attempted, NOT
       whether a background sync is in flight. handleSubmit() chains
       queueBridgeSync() before addToCart(), so in-flight syncs are safe.
       Tying the CTA to hasUnsyncedChanges made it grey out at perfectly
       valid quantities every time the customer typed. */
    var canSubmit = state.bridgeReady && !state.isSubmitting && localValidation.valid;
    var syncNoteText = '';

    if (els.unitPrice) els.unitPrice.textContent = formatMoney(summary.unitPrice);
    if (els.subtotal) els.subtotal.textContent = formatMoney(summary.subtotal);
    if (els.bottomBarUnitPrice) els.bottomBarUnitPrice.textContent = formatMoney(summary.unitPrice);
    if (els.bottomBarSubtotal) els.bottomBarSubtotal.textContent = formatMoney(summary.subtotal);

    /* Payment choice: reflect persisted preference and show the split. */
    if (els.payModeFull && els.payModeDeposit) {
      els.payModeFull.checked = !state.depositSelected;
      els.payModeDeposit.checked = !!state.depositSelected;
      els.payModeFull.disabled = state.isSubmitting;
      els.payModeDeposit.disabled = state.isSubmitting;
    }
    if (els.depositHint) {
      if (state.depositSelected) {
        /* Conversion copy: lead with the low amount due today (brand purple,
           bold = primary focus); the balance reads as quiet reassurance.
           Whole-dollar amounts ($171, not $171.00) lower perceived cost.
           No financing/installment language — one deposit, one balance. */
        var depositPct = toNumber(pricing.depositPercent, 50);
        var depositAmt = summary.subtotal * (depositPct / 100);
        var trim = function (v) { return formatMoney(v).replace(/\.00(\D|$)/, '$1'); };
        els.depositHint.innerHTML =
          '<strong class="xeist-pay-hint-primary">Only ' + trim(depositAmt) + ' Due Today</strong>' +
          '<span class="xeist-pay-hint-secondary">Remaining ' + trim(summary.subtotal - depositAmt) + ' due before shipping</span>';
      } else {
        var teaserPct = toNumber(pricing.depositPercent, 50);
        els.depositHint.textContent = 'pay just ' + teaserPct + '% now, rest before shipping';
      }
      /* Phones hide the teaser hint until deposit is actually selected. */
      els.depositHint.setAttribute('data-active', state.depositSelected ? '1' : '0');
    }

    /* Price transparency: itemize the number fee, celebrate the free logo.
       The per-bag price must never change without the reason on screen. */
    if (els.bottomBarFeeNote) {
      /* Mock 2026-06-11: single short line — "incl. $X number". The free
         logo is celebrated in the volume-pricing footnote instead, so this
         note can never wrap the price card on phones. */
      var numberFee = toNumber(pricing.numberUpcharge, 0) * summary.fx;
      els.bottomBarFeeNote.textContent = (numberFee > 0 && hasNumberSelection())
        ? 'incl. ' + formatMoney(numberFee) + ' number'
        : '';
    }

    if (els.nextTier) {
      if (summary.nextTier) {
        els.nextTier.textContent = summary.remaining + ' more for ' + formatMoney(summary.nextTier.unitPrice * summary.fx) + ' per ' + NOUN + '.';
      } else {
        els.nextTier.textContent = 'Best volume tier is already active.';
      }
    }

    /* Never rewrite the field while the customer is typing in it —
       doing so turned "e5" into "15" and made multi-digit entry impossible. */
    if (els.qtyInput) {
      if (document.activeElement !== els.qtyInput) {
        els.qtyInput.value = String(summary.quantity);
      }
      els.qtyInput.disabled = state.isSubmitting;
    }

    if (els.bottomBarQtyInput) {
      if (document.activeElement !== els.bottomBarQtyInput) {
        els.bottomBarQtyInput.value = String(summary.quantity);
      }
      els.bottomBarQtyInput.disabled = state.isSubmitting;
    }

    if (els.qtyDisplay) {
      els.qtyDisplay.textContent = summary.quantity + ' ' + nounFor(summary.quantity);
    }

    if (els.logoChip) {
      var logoOn = !!(state.context && state.context.logoSelected);
      els.logoChip.textContent = logoOn ? 'Logo on' : 'Logo off';
      els.logoChip.setAttribute('data-active', logoOn ? 'true' : 'false');
    }

    // Customer-facing copy — no internal jargon ("KitBuilder", "coach order
    // draft", "sync"). The note appears next to the Add to Cart CTA.
    var noteTone = '';
    if (!state.bridgeReady) {
      syncNoteText = 'Preparing your customizer…';
    } else if (state.isSubmitting) {
      syncNoteText = 'Adding to your cart…';
    } else if (!localValidation.valid) {
      /* Minimum-order message takes priority over sync chatter — it is the
         one thing the customer must act on. */
      syncNoteText = localValidation.reasons[0];
      noteTone = 'warning';
    } else if (state.isSyncing || state.hasUnsyncedChanges) {
      syncNoteText = 'Saving your changes…';
    } else if (!state.hasAttemptedSubmit) {
      syncNoteText = 'Ready — add to cart when you are';
    } else if (bridgeValid) {
      syncNoteText = 'Ready to add to cart';
    } else {
      syncNoteText = 'Please review your order before checkout';
    }

    if (els.syncNote) {
      els.syncNote.textContent = syncNoteText;
      els.syncNote.setAttribute('data-tone', noteTone);
    }

    /* Conversion redesign 2026-06-11: dynamic helpers below the metrics.
       All values flow from the same summary (config tiers x live FX). */
    if (els.bottomBarSubNote) {
      els.bottomBarSubNote.textContent = 'for ' + summary.quantity + ' ' + nounFor(summary.quantity);
    }
    if (els.tierNudge && els.tierNudgeText) {
      /* 2026-06-18: mobile now uses the SAME dynamic tier nudge as desktop
         (per request). Show "Add N more bags" while a higher pricing tier is
         still reachable; once at the best tier, show the discounts line. */
      if (summary.nextTier && summary.remaining > 0) {
        els.tierNudgeText.textContent = 'Add ' + summary.remaining + ' more ' + nounFor(summary.remaining) + ' to unlock the next pricing tier';
      } else {
        els.tierNudgeText.textContent = 'Volume discounts applied automatically';
      }
      els.tierNudge.hidden = false;
    }
    if (els.volumeTable) {
      renderVolumeTable(summary);
    }

    if (els.bottomBarNote) {
      els.bottomBarNote.textContent = syncNoteText;
      els.bottomBarNote.setAttribute('data-tone', noteTone);
    }

    if (els.qtyDown) els.qtyDown.disabled = state.isSubmitting || summary.quantity <= minQty;
    if (els.qtyUp) els.qtyUp.disabled = state.isSubmitting || summary.quantity >= maxQty;
    if (els.bottomBarQtyDown) els.bottomBarQtyDown.disabled = state.isSubmitting || summary.quantity <= minQty;
    if (els.bottomBarQtyUp) els.bottomBarQtyUp.disabled = state.isSubmitting || summary.quantity >= maxQty;
    if (els.uploadLogo) els.uploadLogo.disabled = !state.bridgeReady || state.isSubmitting;

    /* Hard-disable only while genuinely unable to act (loading/submitting).
       For below-minimum quantities the CTA stays clickable but styled as
       blocked — clicking surfaces/pulses the message instead of dying
       silently on a disabled element. */
    var hardDisabled = !state.bridgeReady || state.isSubmitting;
    var blocked = !hardDisabled && !localValidation.valid;

    if (els.cta) {
      els.cta.disabled = hardDisabled;
      els.cta.classList.toggle('is-blocked', blocked);
      els.cta.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      els.cta.textContent = state.isSubmitting ? 'Submitting...' : 'Add to Cart';
    }

    if (els.bottomBarCta) {
      els.bottomBarCta.disabled = hardDisabled;
      els.bottomBarCta.classList.toggle('is-blocked', blocked);
      els.bottomBarCta.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      var bbCtaLabel = els.bottomBarCta.querySelector('[data-cta-label]');
      (bbCtaLabel || els.bottomBarCta).textContent = state.isSubmitting ? 'Submitting...' : 'Add to Cart';
    }

    updateStatusBadge(messages);
    renderValidation(messages);
  }

  function setReadyClass(enabled) {
    var body = document.body;
    if (!body) return;
    if (enabled) {
      body.classList.add('xeist-coach-panel-ready');
    } else {
      body.classList.remove('xeist-coach-panel-ready');
    }
  }

  function kickPreviewLayout() {
    if (previewKickDone) return;
    previewKickDone = true;

    [60, 220, 520].forEach(function (delay) {
      window.setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, delay);
    });
  }

  function ensureMounted() {
    if (!state.bridgeReady) return;

    var previewPanel = document.querySelector('.kb-preview-panel');
    var editPanel = document.querySelector('.kb-customise-edit-panel');
    if (!previewPanel || !editPanel) return;

    var desktop = window.innerWidth >= 990;
    if (desktop) {
      if (root.parentNode !== editPanel || root !== editPanel.firstChild) {
        editPanel.insertBefore(root, editPanel.firstChild);
      }
      root.classList.add('xeist-coach-order-panel--mounted-desktop');
      root.classList.remove('xeist-coach-order-panel--mounted-mobile');
    } else {
      var previewParent = previewPanel.parentNode;
      if (previewParent && root.parentNode !== previewParent) {
        previewPanel.insertAdjacentElement('afterend', root);
      } else if (previewPanel.nextSibling !== root) {
        previewPanel.insertAdjacentElement('afterend', root);
      }
      root.classList.add('xeist-coach-order-panel--mounted-mobile');
      root.classList.remove('xeist-coach-order-panel--mounted-desktop');
    }

    root.hidden = false;
    state.panelMounted = true;
    kickPreviewLayout();
  }

  function updateValidationFromBridge() {
    if (!bridge) return;
    state.validation = bridge.validateBeforeSubmit();
  }


  function scheduleSync(delay) {
    if (!bridge) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      queueBridgeSync();
    }, typeof delay === 'number' ? delay : 220);
  }

  function setSyncError(message) {
    state.syncError = message || 'Coach order could not sync.';
    state.isSyncing = false;
    state.hasUnsyncedChanges = true;
    updateValidationFromBridge();
    render();
  }

  var SYNC_TIMEOUT_MS = 12000; // 12 s — if syncQuantity hangs, recover

  function withTimeout(promise, ms) {
    var timer;
    return Promise.race([
      promise,
      new Promise(function (_, reject) {
        timer = window.setTimeout(function () {
          reject({ ok: false, code: 'sync_timeout', message: 'Sync timed out after ' + ms + 'ms' });
        }, ms);
      })
    ]).then(function (v) { window.clearTimeout(timer); return v; },
            function (e) { window.clearTimeout(timer); throw e; });
  }

  function queueBridgeSync() {
    if (!bridge || !state.bridgeReady) return syncChain;

    var requestId = ++syncRequestId;

    state.isSyncing = true;
    state.syncError = null;
    state.hasUnsyncedChanges = true;
    render();

    /* Size mode: push the whole per-size map (and the breakdown that rides to
       the cart) instead of a single quantity. Same chained/timeout/parity
       handling; the bridge derives quantity = sum of sizes. */
    if (SIZE_MODE) {
      syncChain = syncChain.then(function () {
        try { bridge.setSizeBreakdown(sizeBreakdown); } catch (e) { /* noop */ }
        return withTimeout(bridge.syncSizes(sizeMap), SYNC_TIMEOUT_MS)
          .then(function (result) {
            if (!result.ok && result.code !== 'parity_pending') throw result;
            if (requestId === syncRequestId) {
              state.isSyncing = false;
              state.hasUnsyncedChanges = false;
              state.syncError = null;
              state.lastSyncedDraftHash = stableStringify({ sizes: sizeMap });
              updateValidationFromBridge();
              render();
            }
          }).catch(function (error) {
            if (requestId === syncRequestId) setSyncError(getResultMessage(error));
          });
      }).catch(function () { syncChain = Promise.resolve(); });
      return syncChain;
    }

    var draft = {
      quantity: state.quantity
    };

    syncChain = syncChain.then(function () {
      return withTimeout(bridge.syncQuantity(draft.quantity), SYNC_TIMEOUT_MS)
        .then(function (result) {
          if (!result.ok) throw result;

          if (requestId === syncRequestId) {
            state.isSyncing = false;
            state.hasUnsyncedChanges = false;
            state.syncError = null;
            state.lastSyncedDraftHash = stableStringify(draft);
            updateValidationFromBridge();
            render();
          }
        }).catch(function (error) {
          if (requestId === syncRequestId) {
            setSyncError(getResultMessage(error));
          }
        });
    }).catch(function () {
      // Safety net: if the outer .then itself throws, reset the chain
      // so future syncs are not permanently blocked.
      syncChain = Promise.resolve();
    });

    return syncChain;
  }

  function getResultMessage(result) {
    if (result && result.validation && result.validation.reasons && result.validation.reasons.length) {
      return result.validation.reasons[0].message;
    }
    if (result && result.code) {
      return 'Coach order sync failed: ' + result.code.replace(/_/g, ' ');
    }
    return 'Coach order sync failed.';
  }

  function handleBridgeSnapshot(snapshot) {
    state.bridgeReady = !!(snapshot && snapshot.ready && snapshot.productSlug === productSlug);
    state.context = snapshot || null;
    if (state.bridgeReady && !state.hydratedFromContext && !state.hasUnsyncedChanges) {
      syncLocalFromContext(snapshot);
    } else if (state.bridgeReady && !state.hasUnsyncedChanges && stableStringify({
      quantity: snapshot.quantity
    }) !== state.lastSyncedDraftHash) {
      syncLocalFromContext(snapshot);
    }

    updateValidationFromBridge();
    ensureMounted();
    setReadyClass(state.bridgeReady && state.panelMounted);
    render();
  }

  function bindBridge() {
    if (!window.XeistKBBridge) return false;
    if (bridgeToken) return true;

    bridge = window.XeistKBBridge;
    bridgeToken = bridge.subscribe(handleBridgeSnapshot);
    return true;
  }


  function handleQuantityChange(nextValue) {
    /* Below-minimum values are KEPT (so the "Add X more" message can refer
       to what the customer actually entered); empty/garbage input restores
       the last known quantity. */
    var parsed = toInt(nextValue, NaN);
    var nextQuantity = isFinite(parsed)
      ? Math.min(maxQty, Math.max(1, parsed))
      : clampQty(state.quantity, minQty);

    state.quantity = nextQuantity;
    state.hasUnsyncedChanges = true;
    state.syncError = null;
    render();
    scheduleSync(120);
  }

  /* Draw the eye to the minimum-order message when a blocked CTA is clicked. */
  function pulseQtyAttention() {
    [els.bottomBarNote, els.syncNote].forEach(function (el) {
      if (!el) return;
      el.classList.remove('xeist-note-pulse');
      void el.offsetWidth; /* restart the animation */
      el.classList.add('xeist-note-pulse');
    });
  }


  function handleUploadLogo() {
    if (!bridge || !state.bridgeReady || state.isSubmitting) return;

    bridge.openLogoUpload().then(function (result) {
      if (!result.ok) {
        state.syncError = getResultMessage(result);
      } else {
        state.syncError = null;
      }
      render();
    });
  }

  /* ─── Fullscreen loading overlay for Add-to-Cart ────────────────────
     The KitBuilder singleitem checkout + Shopify cart handoff takes 15-30s.
     CRITICAL: KitBuilder's checkout BLOCKS THE MAIN THREAD, which means
     requestAnimationFrame and setTimeout callbacks cannot fire.
     We use CSS animations on `transform: scaleX()` instead — these run
     on the browser's compositor thread and keep animating even when JS
     is completely blocked.
     ──────────────────────────────────────────────────────────────────── */
  var loadingOverlay = null;
  var submitStartedAt = 0;   /* set in handleSubmit; anchors kbConsoleRing timing */
  var loadingStyleEl = null;
  var loadingMsgTimer = null;
  var loadingWatchdogTimer = null;
  // If KitBuilder accepted the add-to-cart but the async cart handoff never
  // redirects (it can fail silently inside KB's cross-origin bundle), the
  // overlay would otherwise spin forever. This watchdog turns that infinite
  // wait into an actionable error once progress genuinely stalls.
  // NOTE: KB's successful handoff itself can take 15-30s (flagged in the
  // punch-list as a latency issue to fix at the KB source), so this ceiling
  // is deliberately generous to avoid aborting a slow-but-valid add.
  /* PROGRESS-AWARE WATCHDOG (2026-09-01). The old flat 40s ceiling was
     measured against a stage whose OBSERVED baseline is 16-18s of pure
     KitBuilder server time (/v1/checkout/singleitem, timed live in the
     browser pane) — under 2.5x headroom on a high-variance remote call.
     A slow-but-valid add therefore surfaced as "taking longer than
     expected", and the retry it invites ADDS A SECOND CART LINE once the
     first add lands. Now: the watchdog watches the bridge's own submission
     stages and only errors after a genuine STALL (no stage change), with a
     hard ceiling, and it NEVER errors without first checking the cart. */
  /* No stall budget exists any more — see startCartHandoffWatchdog for why
     every timing-based guess produced false failures on healthy adds. */
  var CART_POLL_INTERVAL_MS = 5000;     // ask the cart itself, every 5 s
  var REASSURE_AFTER_MS = 40000;        // past a normal add: reassure, never error
  /* The only bound. Measured: 16 s at 6 bags, 44 s at 22, so a 50- or 100-bag
     order can legitimately run several minutes. Only a genuinely hung
     handoff should ever reach this. */
  var CART_HANDOFF_ABSOLUTE_MS = 420000;
  var SLOW_REPORT_AFTER_MS = 90000;     // one interim self-report, see the poll
  var slowReported = false;
  var CART_HANDOFF_POLL_MS = 2000;
  var cartBaselineCount = null;        // /cart.js item_count captured at submit
  var cartBaselineAt = 0;
  var cartBaselineError = null;        // why the baseline read failed, if it did
  var handoffTape = [];                // [msSinceSubmit, stage-signature] pairs

  /* SELF-REPORTING (2026-09-01). Two sessions were spent failing to reproduce
     a customer-facing failure from a screenshot: every timed run in a clean
     browser SUCCEEDED (16-23 s, nearly all of it KitBuilder server time). So
     the failure now reports itself. On a stall we post the stage tape to the
     Worker's /beacon route, which relays to #customizer-alerts server-side —
     the same relay the health beacon uses, so no webhook ships in this asset.
     Fire-and-forget: reporting must never delay or break the customer's UI. */
  function reportHandoffStall(detail) {
    try {
      try {
        var dd = window.XeistKBBridgeDebug && window.XeistKBBridgeDebug.getState
          ? window.XeistKBBridgeDebug.getState() : {};
        var sb = dd.lastSubmission || {}, rq = dd.lastCartRequest || {}, rs = dd.lastCartResponse || {};
        detail.subStatus = String(sb.status || 'none') +
          (sb.trigger ? ' via ' + sb.trigger : '') +   /* bridge v11: which channel fired KB's addToCart */
          (sb.responseStatus != null ? ' http' + sb.responseStatus : '') +
          (sb.responseError ? ' err=' + String(sb.responseError).slice(0, 40) : '');
        detail.reqKind = String(rq.kind || 'none');
        detail.sawCheckout = !!sawKbCheckout;
        detail.gotResponse = !!(rs.observedAt && rq.observedAt && rs.observedAt >= rq.observedAt);
        var v = (dd.lastValidation && dd.lastValidation.validation) || {};
        detail.validation = (v.valid ? 'valid' : 'INVALID') +
          (v.reasons && v.reasons.length
            ? ' [' + v.reasons.map(function (r) { return r && (r.code || r.message) || String(r); }).join(', ') + ']'
            : '');
      } catch (e) { detail.subStatus = detail.reqKind = detail.validation = 'unreadable'; }
      var api = String((window.XeistConfig || {}).sessionApi || '').replace(/\/+$/, '');
      if (!api) return;
      var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || '?';
      var tape = handoffTape.map(function (r) { return r[0] + 'ms ' + r[1]; }).join(' -> ');
      var text = [
        (detail.failure
          ? ':rotating_light: CART HANDOFF *FAILED* (' + detail.failure.status + '/' + detail.failure.code + ')' +
            (detail.failure.kbErrors ? ' KB: ' + detail.failure.kbErrors : '')
          : detail.tag
            ? ':warning: CART HANDOFF ' + detail.tag + ' (at ' + Math.round(detail.totalMs / 1000) + ' s visible)'
          : detail.slow
            ? ':hourglass_flowing_sand: CART HANDOFF SLOW (still waiting at ' + Math.round(detail.totalMs / 1000) + ' s)'
            : ':rotating_light: CART HANDOFF STALL') + ' \u2014 design ' + design,
        'qty ' + state.quantity + ' | pay ' + (state.depositSelected ? 'deposit' : 'full') +
          ' | layout ' + (stepped && stepped.layout ? stepped.layout : 'classic') +
          ' | ' + window.innerWidth + 'px',
        'stalled ' + detail.stalledMs + 'ms, visible-total ' + detail.totalMs + 'ms, hidden ' + detail.hiddenMs + 'ms',
        'cart baseline ' + (cartBaselineCount === null ? 'UNAVAILABLE (' + cartBaselineError + ')' : cartBaselineCount) +
          ' -> after ' + detail.cartAfter + ' | grew: ' + detail.grew,
        /* An empty tape is ambiguous on its own: it means no stage CHANGED,
           which reads the same whether KitBuilder never issued its checkout
           call or issued it and never answered. These three fields separate
           those two for good. */
        'submission ' + detail.subStatus + ' | lastReq ' + detail.reqKind +
          ' | KB checkout ever issued: ' + detail.sawCheckout +
          ' | KB answered: ' + detail.gotResponse,
        'kb validation: ' + detail.validation,
        (kbConsoleRing.length ? 'kb console: ' + kbConsoleRing.join(' | ') : 'kb console: (silent)'),
        'tape: ' + tape,
        String(navigator.userAgent || '').slice(0, 90)
      ].join('\n').slice(0, 600);
      /* sendBeacon survives the page being closed on the error screen. */
      var body = JSON.stringify({ text: text });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(api + '/beacon', new Blob([body], { type: 'text/plain' }));
      } else {
        fetch(api + '/beacon', { method: 'POST', body: body, keepalive: true }).catch(function () {});
      }
    } catch (e) { /* reporting must never break the page */ }
  }

  /* Cart truth, used to tell "slow" apart from "failed". Any read error
     resolves to null so a network hiccup never invents a success. */
  function readCartCount() {
    try {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { return c ? (c.item_count | 0) : null; })
        .catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  function captureCartBaseline() {
    cartBaselineCount = null;
    cartBaselineError = 'pending';
    sawKbCheckout = false;
    slowReported = false;
    lastCartPollAt = 0;
    cartBaselineAt = Date.now();
    handoffTape = [];
    readCartCount().then(function (n) {
      if (n !== null) { cartBaselineCount = n; cartBaselineError = null; }
      else { cartBaselineError = 'read failed'; }
    });
  }

  /* Resolves true when the cart grew since the baseline — i.e. the add
     actually landed and only the redirect was lost. */
  var lastCartAfter = null;
  function cartGrewSinceSubmit() {
    return readCartCount().then(function (n) {
      lastCartAfter = n;
      /* No baseline (the pre-submit read failed — private browsing, an
         offline blip, a blocked request) means we can prove neither that the
         add landed nor that it didn't. Say "didn't grow" so the coach still
         gets a way forward, but the beacon records the ambiguity so this case
         is never again mistaken for a real KitBuilder failure. */
      if (cartBaselineCount === null) return false;
      return n !== null && n > cartBaselineCount;
    });
  }

  function redirectToCart() {
    try { completeLoadingOverlay(); } catch (e) { /* noop */ }
    try { window.location.assign('/cart'); } catch (e) { window.location.href = '/cart'; }
  }

  /* One signature per observable stage of the handoff. Any change = progress.
     Stages come from the bridge's own debug store, which the response
     observer updates as KB's checkout XHR and the Shopify /cart/add.js
     handoff move: started -> native_triggered -> submitted ->
     shopify_handoff_started -> shopify_cart_added. */
  function handoffProgressSignature() {
    try {
      var d = window.XeistKBBridgeDebug && window.XeistKBBridgeDebug.getState
        ? window.XeistKBBridgeDebug.getState() : null;
      if (!d) return 'nodebug';
      var sub = d.lastSubmission || {};
      var req = d.lastCartRequest || {};
      var res = d.lastCartResponse || {};
      return [sub.status, sub.startedAt, req.kind, req.observedAt, res.observedAt, res.status].join('|');
    } catch (e) { return 'err'; }
  }

  /* TERMINAL FAILURE, NOT A STALL (2026-09-01, Justin's cart proved it).
     When KitBuilder answers /v1/checkout/singleitem with 200 but no variantId
     — the classic case is {"errors":["qty must be a valid positive integer"]}
     — the bridge detects it IMMEDIATELY and records
     status:'handoff_failed', handoffError:'no_variant_id' ... and then
     returns silently. Nothing told this panel, so the overlay span until the
     watchdog fired and blamed latency for an add that was already dead, with
     the cart correctly never growing. Any '*_failed' status is terminal:
     stop at once and say so, instead of spending 45 s pretending to wait. */
  function terminalHandoffFailure() {
    try {
      var d = window.XeistKBBridgeDebug && window.XeistKBBridgeDebug.getState
        ? window.XeistKBBridgeDebug.getState() : null;
      var sub = d && d.lastSubmission;
      /* 'response_error' (2026-09-02): the bridge records it when KitBuilder's
         checkout XHR/fetch ENDS WITHOUT A RESPONSE — network error, abort, a
         cellular carrier or proxy cutting a 45-60 s request. The old
         /failed$/ test skipped it, so a phone whose request died spun forever
         (Justin, iPhone, sheet layout, 2+ minutes, no beacon). Terminal. */
      if (!sub || !sub.status) return null;
      var st = String(sub.status);
      if (!/failed$/.test(st) && st !== 'response_error') return null;
      /* KitBuilder states its own reason; keep it for the beacon and console
         rather than putting engine-speak in front of a coach. */
      var kbErrors = null;
      try {
        var rj = sub.responseJson || (d.lastCartResponse && d.lastCartResponse.json);
        if (rj && rj.errors) kbErrors = [].concat(rj.errors).join('; ');
      } catch (e) { /* noop */ }
      return {
        status: String(sub.status),
        code: String(sub.handoffError || sub.error || sub.responseError || 'unknown'),
        kbErrors: kbErrors
      };
    } catch (e) { return null; }
  }

  /* KITBUILDER'S CHECKOUT TIME SCALES WITH QUANTITY (2026-09-01, measured).
     /v1/checkout/singleitem answers in ~16-23 s for 6 bags but **43.7 s for
     22** — and the run still succeeded, landing "Orbit Backpack. (x 22)" in
     the cart at 46.7 s. That is what Justin hit: the beacon recorded qty 22,
     stalled 46532ms, cart "grew: false" — because at the instant we looked,
     KitBuilder simply had not answered YET. A request we are still waiting on
     is not a stall, however long it takes, so the watchdog must never fire
     while one is outstanding. Bigger orders will take longer still; the only
     honest ceiling is the outer one below. */
  var sawKbCheckout = false;   // did KitBuilder ever ISSUE its checkout call?
  var lastCartPollAt = 0;

  function startCartHandoffWatchdog() {
    stopCartHandoffWatchdog();
    var startedAt = Date.now();
    var lastSig = handoffProgressSignature();
    var lastProgressAt = startedAt;

    /* HIDDEN TIME DOES NOT COUNT (2026-09-01). The handoff takes 16-25 s of
       KitBuilder server time, which is long enough that a coach switches tabs
       or apps while they wait. Chrome then throttles the background tab's
       timers to roughly one tick a minute and freezes them outright after
       ~5 minutes, so NOTHING progresses — not KB's own callbacks, not the
       Shopify handoff, not this watchdog. Counting that dead time as a stall
       accuses a perfectly healthy add of failing the moment the coach comes
       back. So we subtract time spent hidden, and give a freshly-visible tab
       the full stall budget again to let throttled work drain. (This is the
       same visibility gate XeistCore.every uses for KB's boot tasks.) */
    var hiddenSince = document.hidden ? Date.now() : 0;
    var hiddenTotal = 0;
    /* PHONES (2026-09-04). A real iPhone is the one surface that keeps
       failing after every desktop pass succeeds, and it is also the one
       surface where a 45-60 s KitBuilder request routinely outlives the
       screen: iOS suspends the page the moment it locks or the coach
       switches apps, in-flight XHRs die there, and nothing fires when they
       do. So: (1) hold a screen wake lock for the duration of the handoff,
       (2) report the moment we go hidden and the moment we return (the
       phone beacons that never arrived were all inside this gap), and
       (3) after a return with no answer, give the handoff a short grace
       window and then hand the coach a cart-checked Try Again instead of
       an endless spinner. */
    var hiddenReported = false, resumedReported = false, abandonReported = false;
    var resumeDeadline = 0;
    var RESUME_GRACE_MS = 25000;
    var wakeLock = null;
    try {
      if (navigator.wakeLock && navigator.wakeLock.request) {
        navigator.wakeLock.request('screen').then(function (l) { wakeLock = l; }).catch(function () { /* denied: fine */ });
      }
    } catch (e) { /* noop */ }
    function beaconTag(tag, immediate) {
      var send = function (grew) {
        reportHandoffStall({
          tag: tag,
          stalledMs: Date.now() - lastProgressAt,
          totalMs: Date.now() - startedAt - hiddenTotal,
          hiddenMs: hiddenTotal + (hiddenSince ? Date.now() - hiddenSince : 0),
          grew: grew, cartAfter: lastCartAfter
        });
      };
      /* Going hidden / leaving: a fetch may never run on a suspending page,
         so send what we know NOW (sendBeacon is queued by the browser). */
      if (immediate) { send('unchecked'); return; }
      cartGrewSinceSubmit().then(send);
    }
    function onVisibility() {
      if (document.hidden) {
        if (!hiddenSince) hiddenSince = Date.now();
        if (handoffTape.length < 40) handoffTape.push([Date.now() - startedAt, 'hidden']);
        if (!hiddenReported) { hiddenReported = true; beaconTag('WENT HIDDEN mid-handoff', true); }
        return;
      }
      var away = hiddenSince ? Date.now() - hiddenSince : 0;
      if (hiddenSince) { hiddenTotal += away; hiddenSince = 0; }
      /* Back in the foreground: restart the stall budget so throttled
         callbacks get a fair chance to land before we judge them. */
      lastProgressAt = Date.now();
      if (handoffTape.length < 40) handoffTape.push([Date.now() - startedAt, 'visible-again']);
      try { if (navigator.wakeLock && navigator.wakeLock.request) navigator.wakeLock.request('screen').then(function (l) { wakeLock = l; }).catch(function () {}); } catch (e) { /* noop */ }
      if (away > 3000) {
        if (!resumedReported) { resumedReported = true; beaconTag('RESUMED after ' + Math.round(away / 1000) + ' s hidden'); }
        /* If KitBuilder still has not answered, the request most likely
           died with the suspended page. Grace, then a way out. */
        var d0 = null;
        try { d0 = window.XeistKBBridgeDebug && window.XeistKBBridgeDebug.getState ? window.XeistKBBridgeDebug.getState() : null; } catch (e) { /* noop */ }
        var st0 = d0 && d0.lastSubmission ? String(d0.lastSubmission.status || '') : '';
        if (st0 && st0 !== 'shopify_cart_added' && st0 !== 'redirecting') resumeDeadline = Date.now() + RESUME_GRACE_MS;
      }
    }
    function onPageHide() {
      if (!loadingOverlay || abandonReported) return;
      abandonReported = true;
      beaconTag('PAGE LEFT with overlay up', true);
    }
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', onPageHide);
    watchdogCleanup = function () {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', onPageHide);
      try { if (wakeLock) { wakeLock.release(); wakeLock = null; } } catch (e) { /* noop */ }
    };

    loadingWatchdogTimer = setInterval(function () {
      if (!loadingOverlay) { stopCartHandoffWatchdog(); return; }

      /* A declared failure is answered immediately, hidden tab or not —
         waiting out a stall budget on a known-dead handoff helps nobody. */
      var failure = terminalHandoffFailure();
      if (failure) {
        stopCartHandoffWatchdog();
        try {
          console.warn('[Xeist Coach Panel] cart handoff failed: ' + failure.status +
            ' (' + failure.code + ')' + (failure.kbErrors ? ' — KitBuilder: ' + failure.kbErrors : ''));
        } catch (e) { /* noop */ }
        cartGrewSinceSubmit().then(function (grew) {
          reportHandoffStall({
            stalledMs: Date.now() - lastProgressAt,
            totalMs: Date.now() - startedAt,
            hiddenMs: hiddenTotal,
            grew: grew, cartAfter: lastCartAfter,
            failure: failure
          });
          if (!loadingOverlay) return;
          if (grew) { redirectToCart(); return; }
          state.isSubmitting = false;
          dismissLoadingOverlay(failure.kbErrors
            ? 'Your order couldn\u2019t be built \u2014 ' + failure.kbErrors + '. Your design is saved.'
            : failure.status === 'response_error'
              ? 'The connection dropped while your order was being built. Your design is saved \u2014 check your cart, then try again.'
              : 'We couldn\u2019t build this order. Your design is saved \u2014 please try again.');
        });
        return;
      }

      if (document.hidden) return; /* never judge a throttled tab */

      /* 'KB checkout ever issued' in the beacon was always false: nothing ever
         set sawKbCheckout. Read it off the bridge's request slot instead. */
      try {
        var dq = window.XeistKBBridgeDebug && window.XeistKBBridgeDebug.getState
          ? window.XeistKBBridgeDebug.getState() : null;
        if (dq && dq.lastCartRequest && dq.lastCartRequest.kind === 'kitbuilder_checkout') sawKbCheckout = true;
      } catch (e) { /* noop */ }

      var sig = handoffProgressSignature();
      if (sig !== lastSig) {
        lastSig = sig;
        lastProgressAt = Date.now();
        resumeDeadline = 0;   /* it moved after we came back: still alive */
        if (handoffTape.length < 40) handoffTape.push([Date.now() - startedAt, sig]);
      }

      if (resumeDeadline && Date.now() > resumeDeadline) {
        resumeDeadline = 0;
        stopCartHandoffWatchdog();
        cartGrewSinceSubmit().then(function (grew) {
          reportHandoffStall({
            tag: 'DEAD after resume',
            stalledMs: Date.now() - lastProgressAt,
            totalMs: Date.now() - startedAt - hiddenTotal,
            hiddenMs: hiddenTotal,
            grew: grew, cartAfter: lastCartAfter
          });
          if (!loadingOverlay) return;
          if (grew) { redirectToCart(); return; }
          state.isSubmitting = false;
          dismissLoadingOverlay('Your phone went to sleep while the order was being built, so it didn\u2019t finish. Your design is saved \u2014 keep the screen on and try again.');
        });
        return;
      }

      var hidden = hiddenTotal + (hiddenSince ? Date.now() - hiddenSince : 0);
      var total = Date.now() - startedAt - hidden;

      /* THE CART IS THE ONLY HONEST SIGNAL (2026-09-01, second correction).
         The stall heuristic is GONE, and the in-flight guard with it.
         (Both are named in HANDOFF.md; the identifiers are deliberately
         not repeated here, so the regression test can assert their
         absence by plain string search.)

         Why the in-flight test could never work: lastCartRequest and
         lastCartResponse are SEPARATE slots that any observed checkout-ish
         call overwrites — they are not a matched pair. KitBuilder issues its
         checkout the instant savebasket resolves, so the sequence is
         checkout REQUEST at t, savebasket RESPONSE at t+6ms. The comparison
         `res.observedAt < req.observedAt` therefore reads false almost
         immediately, against a response belonging to a different call, and
         the guard never engaged. Measured twice: req ...553042 / res
         ...553048, and req ...718867 / res ...718870.

         With the guard inert the signature goes quiet at ~1.5 s and stays
         quiet until KB's body lands ~44 s later, so "no progress" was
         indistinguishable from "working normally" — hence every beacon
         reading stalled ~46000ms with an EMPTY tape, on desktop and iPhone
         alike, and the single run that passed did so by beating the budget by
         seconds rather than by being fixed.

         Matching request to response properly would mean changing the bridge.
         The cart needs no such trust: poll it, and give up only at the outer
         bound. */
      if (total - lastCartPollAt > CART_POLL_INTERVAL_MS) {
        lastCartPollAt = total;
        cartGrewSinceSubmit().then(function (grew) {
          if (grew && loadingOverlay) { stopCartHandoffWatchdog(); redirectToCart(); }
        });
      }

      /* Long orders are slow, not broken — KitBuilder's checkout time scales
         with quantity (16 s at 6 bags, 44 s at 22). Say so rather than
         letting the coach think it has hung. */
      if (total > REASSURE_AFTER_MS) {
        var note = document.getElementById('xeist-loading-note');
        if (note && note.dataset.xfLong !== '1') {
          note.dataset.xfLong = '1';
          note.textContent = 'Large orders take longer to build \u2014 still working. Please don\u2019t close this page';
        }
      }

      /* INTERIM SELF-REPORT (2026-09-02). Between the 40 s reassurance and
         the 7-minute bound the page was silent, so a coach who gives up at
         2-3 minutes leaves no trace. Once past SLOW_REPORT_AFTER_MS, post the
         same tape a stall would — tagged SLOW, not failed — so the next slow
         phone run explains itself in #customizer-alerts. */
      if (total > SLOW_REPORT_AFTER_MS && !slowReported) {
        slowReported = true;
        cartGrewSinceSubmit().then(function (grew) {
          reportHandoffStall({
            slow: true,
            stalledMs: Date.now() - lastProgressAt,
            totalMs: Date.now() - startedAt,
            hiddenMs: hiddenTotal,
            grew: grew, cartAfter: lastCartAfter
          });
        });
      }

      if (total < CART_HANDOFF_ABSOLUTE_MS) return;

      /* THE OUTER BOUND (restored 2026-09-02 — the branch had been left
         empty, so past 7 minutes the overlay simply never ended). Check the
         cart one last time, report, and hand the coach a way forward. */
      stopCartHandoffWatchdog();
      cartGrewSinceSubmit().then(function (grew) {
        reportHandoffStall({
          stalledMs: Date.now() - lastProgressAt,
          totalMs: Date.now() - startedAt,
          hiddenMs: hiddenTotal,
          grew: grew, cartAfter: lastCartAfter
        });
        if (!loadingOverlay) return;
        if (grew) { redirectToCart(); return; }
        state.isSubmitting = false;
        dismissLoadingOverlay('This is taking much longer than usual. Your design is saved \u2014 please check your cart before trying again.');
      });

    }, CART_HANDOFF_POLL_MS);
  }

  var watchdogCleanup = null;
  function stopCartHandoffWatchdog() {
    if (watchdogCleanup) { try { watchdogCleanup(); } catch (e) { /* noop */ } watchdogCleanup = null; }
    if (!loadingWatchdogTimer) return;
    clearInterval(loadingWatchdogTimer);
    clearTimeout(loadingWatchdogTimer);
    loadingWatchdogTimer = null;
  }

  // KitBuilder reports a failed cart handoff by logging to console from its
  // cross-origin bundle (observed: "Error adding to cart. Errors: [...]").
  // We can't catch that as a promise rejection, but we can watch console.error
  // so a failure surfaces to the customer in seconds rather than after the
  // 40s watchdog. Installed once; only acts while our overlay is visible.
  /* KB CONSOLE TAP (2026-09-04). The phone beacon proved the stall is inside
     KitBuilder, BEFORE it issues checkout (submission stuck at
     native_triggered, lastReq kitbuilder_jwt, KB checkout ever issued:
     false) and with the page fully awake (hidden 0ms) — so it is neither
     phone-sleep nor our handoff. The one thing we still lack is KB's own
     reason, which only the failing phone can give. Buffer KB's console
     error/warn while the overlay is up so the beacon carries it: the next
     phone tap names the cause instead of us guessing a 5th time. */
  var kbConsoleRing = [];
  function kbConsolePush(level, args) {
    try {
      if (!loadingOverlay && !state.isSubmitting) return; /* only while submitting */
      var text = Array.prototype.map.call(args, function (a) {
        return (a && a.message) ? a.message : String(a);
      }).join(' ');
      /* KB and cart-relevant lines only — keep the ring small and on-topic. */
      if (!/cart|basket|checkout|kitbuilder|kb\.|singleitem|jwt|save|variant|shopify|error|fail|undefined|null is not|not a function/i.test(text)) return;
      kbConsoleRing.push(Math.round((Date.now() - (submitStartedAt || Date.now())) / 100) / 10 + 's ' + level + ':' + text.slice(0, 160));
      if (kbConsoleRing.length > 12) kbConsoleRing.shift();
    } catch (e) { /* never let monitoring break logging */ }
  }
  (function installCartErrorMonitor() {
    if (window.__xeistCartErrorMonitor) return;
    window.__xeistCartErrorMonitor = true;
    var origError = console.error.bind(console);
    var origWarn = console.warn.bind(console);
    console.error = function () {
      kbConsolePush('E', arguments);
      try {
        var text = Array.prototype.map.call(arguments, function (a) {
          return (a && a.message) ? a.message : String(a);
        }).join(' ');
        if (loadingOverlay && /error adding to cart/i.test(text)) {
          state.isSubmitting = false;
          dismissLoadingOverlay('We couldn’t add this to your cart. Your design is saved — please try again.');
        }
      } catch (e) { /* never let monitoring break logging */ }
      return origError.apply(console, arguments);
    };
    console.warn = function () {
      kbConsolePush('W', arguments);
      return origWarn.apply(console, arguments);
    };
    /* Uncaught errors (KB throws that never reach console.error) — the most
       likely shape of a silent iOS-only failure. */
    window.addEventListener('error', function (ev) {
      if (!loadingOverlay && !state.isSubmitting) return;
      try {
        kbConsoleRing.push(Math.round((Date.now() - (submitStartedAt || Date.now())) / 100) / 10 + 's X:' +
          String((ev && ev.message) || 'error').slice(0, 120) +
          ((ev && ev.filename) ? ' @' + String(ev.filename).split('/').pop().slice(0, 40) + ':' + (ev.lineno || '?') : ''));
        if (kbConsoleRing.length > 12) kbConsoleRing.shift();
      } catch (e) { /* noop */ }
    }, true);
    window.addEventListener('unhandledrejection', function (ev) {
      if (!loadingOverlay && !state.isSubmitting) return;
      try {
        var r = ev && ev.reason;
        kbConsoleRing.push(Math.round((Date.now() - (submitStartedAt || Date.now())) / 100) / 10 + 's P:' +
          String((r && r.message) || r || 'rejection').slice(0, 140));
        if (kbConsoleRing.length > 12) kbConsoleRing.shift();
      } catch (e) { /* noop */ }
    });
  })();

  // Inject the CSS keyframes + animations once
  function injectLoadingStyles() {
    if (loadingStyleEl) return;
    loadingStyleEl = document.createElement('style');
    loadingStyleEl.textContent = [
      '/* Progress bar: CSS-driven on compositor thread — survives main-thread blocking */',
      '/* Fill targets are aligned to the status-message milestones below so the',
      '   bar visibly arrives at each stage as its message appears. Keyframe %',
      '   == elapsed-second fraction of the 28s timeline (animation is linear),',
      '   e.g. 11% ≈ 3s = "Saving your design". Each milestone has a short settle',
      '   (the pair of close keyframes) so the stage reads as "reached". */',
      '@keyframes xeist-bar-fill {',
      '  0%   { transform: scaleX(0.05); }  /* 0s  · Preparing */',
      '  9%   { transform: scaleX(0.18); }',
      '  11%  { transform: scaleX(0.20); }  /* 3s  · Saving your design */',
      '  23%  { transform: scaleX(0.40); }',
      '  25%  { transform: scaleX(0.42); }  /* 7s  · Building products */',
      '  41%  { transform: scaleX(0.60); }',
      '  43%  { transform: scaleX(0.62); }  /* 12s · Generating details */',
      '  62%  { transform: scaleX(0.78); }',
      '  64%  { transform: scaleX(0.80); }  /* 18s · Almost there */',
      '  84%  { transform: scaleX(0.89); }',
      '  86%  { transform: scaleX(0.90); }  /* 24s · Adding to cart */',
      '  100% { transform: scaleX(0.92); }  /* hold ceiling until complete */',
      '}',
      '',
      '/* Shimmer on the bar for extra "alive" feel */',
      '@keyframes xeist-bar-shimmer {',
      '  0%   { background-position: -200% 0; }',
      '  100% { background-position: 200% 0; }',
      '}',
      '',
      '/* Gentle pulse on the card so something always moves */',
      '@keyframes xeist-card-pulse {',
      '  0%, 100% { transform: scale(1); }',
      '  50%      { transform: scale(1.008); }',
      '}',
      '',
      '/* Dot animation for the message */',
      '@keyframes xeist-dots {',
      '  0%, 20%  { opacity: 0; }',
      '  40%, 100% { opacity: 1; }',
      '}',
      '',
      '#xeist-loading-bar-fill {',
      '  transform-origin: left center;',
      '  will-change: transform;',
      '  background: linear-gradient(90deg, #15803d 0%, #22c55e 45%, #4ade80 50%, #22c55e 55%, #15803d 100%);',
      '  background-size: 200% 100%;',
      '  animation: xeist-bar-fill 28s linear forwards,',
      '             xeist-bar-shimmer 2s linear infinite;',
      '}',
      '',
      '#xeist-loading-card {',
      '  animation: xeist-card-pulse 3s ease-in-out infinite;',
      '}',
      '',
      '#xeist-loading-bar-fill.xeist-bar-complete {',
      '  animation: none !important;',
      '  transition: transform 0.6s ease-out;',
      '  transform: scaleX(1);',
      '  background: linear-gradient(90deg, #15803d, #22c55e);',
      '}',
      '',
      '#xeist-loading-bar-fill.xeist-bar-error {',
      '  animation: none !important;',
      '  background: #dc2626;',
      '}',
      '',
      '#xeist-loading-dots span {',
      '  opacity: 0;',
      '  animation: xeist-dots 1.4s infinite;',
      '}',
      '#xeist-loading-dots span:nth-child(2) { animation-delay: 0.2s; }',
      '#xeist-loading-dots span:nth-child(3) { animation-delay: 0.4s; }',
      '',
      '/* Reduced motion: keep the informative bar fill, drop decorative motion',
      '   (shimmer, card pulse, dot cycling — dots become static ellipsis). */',
      '@media (prefers-reduced-motion: reduce) {',
      '  #xeist-loading-bar-fill { animation: xeist-bar-fill 28s linear forwards; }',
      '  #xeist-loading-card { animation: none !important; }',
      '  #xeist-loading-dots span { animation: none !important; opacity: 1 !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(loadingStyleEl);
  }

  // Status messages shown at timed intervals (since we can't rely on JS during blocking)
  var LOADING_MESSAGES = [
    { afterSec: 0,  text: 'Preparing your custom order' },
    { afterSec: 3,  text: 'Saving your design' },
    { afterSec: 7,  text: 'Building your custom products' },
    { afterSec: 12, text: 'Generating your order details' },
    { afterSec: 18, text: 'Almost there \u2014 finalizing pricing' },
    { afterSec: 24, text: 'Adding to your cart' }
  ];

  function showLoadingOverlay() {
    if (loadingOverlay) return;

    injectLoadingStyles();

    var overlay = document.createElement('div');
    overlay.id = 'xeist-cart-loading-overlay';
    overlay.style.cssText = [
      'position: fixed', 'inset: 0', 'z-index: 999999',
      'display: flex', 'flex-direction: column', 'align-items: center', 'justify-content: center',
      'background: rgba(0, 0, 0, 0.72)', 'backdrop-filter: blur(6px)',
      '-webkit-backdrop-filter: blur(6px)',
      'opacity: 1'
    ].join(';');

    var card = document.createElement('div');
    card.id = 'xeist-loading-card';
    /* Dialog semantics + programmatic focus so screen readers land inside
       the overlay instead of the (visually hidden) page behind it. */
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.setAttribute('aria-labelledby', 'xeist-loading-heading');
    card.setAttribute('aria-describedby', 'xeist-loading-message');
    card.setAttribute('tabindex', '-1');
    card.style.cssText = [
      'background: #fff', 'border-radius: 16px', 'padding: 40px 48px',
      'max-width: 420px', 'width: 90%', 'text-align: center',
      'box-shadow: 0 20px 60px rgba(0,0,0,0.3)', 'outline: none'
    ].join(';');

    var icon = document.createElement('div');
    icon.id = 'xeist-loading-icon';
    icon.style.cssText = 'font-size: 48px; margin-bottom: 16px;';
    icon.textContent = '\uD83C\uDFA8';

    var heading = document.createElement('div');
    heading.id = 'xeist-loading-heading';
    heading.style.cssText = 'font-family: inherit; font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 6px;';
    heading.textContent = 'Building Your Custom Order';

    var message = document.createElement('div');
    message.id = 'xeist-loading-message';
    /* Announce each stage change ("Saving your design", …) to screen readers. */
    message.setAttribute('aria-live', 'polite');
    message.style.cssText = 'font-family: inherit; font-size: 15px; color: #666; margin-bottom: 24px; min-height: 22px;';
    message.innerHTML = LOADING_MESSAGES[0].text + '<span id="xeist-loading-dots"><span>.</span><span>.</span><span>.</span></span>';

    var trackOuter = document.createElement('div');
    /* The fill is CSS-animation-driven (survives main-thread blocking), so a
       live aria-valuenow isn't possible — expose as an indeterminate bar. */
    trackOuter.setAttribute('role', 'progressbar');
    trackOuter.setAttribute('aria-label', 'Building your order');
    trackOuter.style.cssText = [
      'width: 100%', 'height: 10px', 'background: #eee',
      'border-radius: 999px', 'overflow: hidden'
    ].join(';');

    var trackFill = document.createElement('div');
    trackFill.id = 'xeist-loading-bar-fill';
    trackFill.style.cssText = [
      'width: 100%', 'height: 100%',
      'border-radius: 999px'
    ].join(';');

    var note = document.createElement('div');
    note.id = 'xeist-loading-note';
    note.style.cssText = 'font-family: inherit; font-size: 12px; color: #999; margin-top: 16px;';
    note.textContent = 'Please don\u2019t close this page';

    trackOuter.appendChild(trackFill);
    card.appendChild(icon);
    card.appendChild(heading);
    card.appendChild(message);
    card.appendChild(trackOuter);
    card.appendChild(note);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    loadingOverlay = overlay;
    loadingStartTime = Date.now();
    /* Move SR/keyboard context into the dialog. No focus restore needed:
       the flow ends in a hard redirect to /cart (or dismiss re-renders). */
    try { card.focus(); } catch (e) { /* non-fatal */ }

    // Time-based message updates.  These won't fire while the thread is
    // blocked, but they'll catch up when unblocked — and the bar keeps
    // moving regardless thanks to CSS animations.
    var msgIndex = 0;
    loadingMsgTimer = setInterval(function () {
      var msg = document.getElementById('xeist-loading-message');
      if (!msg) return;
      var elapsed = (Date.now() - loadingStartTime) / 1000;
      var newIndex = 0;
      for (var i = 0; i < LOADING_MESSAGES.length; i++) {
        if (elapsed >= LOADING_MESSAGES[i].afterSec) newIndex = i;
      }
      if (newIndex !== msgIndex) {
        msgIndex = newIndex;
        msg.innerHTML = LOADING_MESSAGES[msgIndex].text + '<span id="xeist-loading-dots"><span>.</span><span>.</span><span>.</span></span>';
      }
    }, 1000);
  }

  var loadingStartTime = 0;

  function completeLoadingOverlay() {
    if (!loadingOverlay) return;

    // Grab the current computed scaleX so we can seamlessly transition to 1.0
    var bar = document.getElementById('xeist-loading-bar-fill');
    if (bar) {
      var cs = window.getComputedStyle(bar);
      var currentTransform = cs.transform; // matrix(a, b, c, d, tx, ty) — scaleX = a
      // Freeze at current position, then transition to full
      bar.style.animation = 'none';
      bar.style.transform = currentTransform;
      // Force reflow so browser registers the static position
      void bar.offsetWidth;
      bar.classList.add('xeist-bar-complete');
    }

    var msg = document.getElementById('xeist-loading-message');
    if (msg) msg.textContent = 'Redirecting to your cart\u2026';

    if (loadingMsgTimer) { clearInterval(loadingMsgTimer); loadingMsgTimer = null; }
    stopCartHandoffWatchdog();
  }

  // Expose so the bridge can call it right before the /cart redirect
  window.__xeistCompleteLoadingOverlay = completeLoadingOverlay;

  function dismissLoadingOverlay(errorMessage) {
    if (!loadingOverlay) return;
    if (loadingMsgTimer) { clearInterval(loadingMsgTimer); loadingMsgTimer = null; }
    stopCartHandoffWatchdog();

    if (errorMessage) {
      // Surface an actionable error in place — the overlay is full-screen and
      // blocking, so we must give the customer a way out (retry or close)
      // rather than silently auto-removing or, worse, spinning forever.
      var msg = document.getElementById('xeist-loading-message');
      var bar = document.getElementById('xeist-loading-bar-fill');
      var heading = document.getElementById('xeist-loading-heading');
      var note = document.getElementById('xeist-loading-note');
      var icon = document.getElementById('xeist-loading-icon');
      if (icon) icon.textContent = '⚠️';
      if (heading) heading.textContent = 'We couldn’t add this to your cart';
      if (msg) {
        msg.textContent = errorMessage;
        msg.style.color = '#dc2626';
      }
      if (bar) { bar.classList.add('xeist-bar-error'); }
      if (note) { note.style.display = 'none'; }

      // Your design is preserved — make that explicit so the customer doesn't
      // fear losing their work.
      var reassure = document.getElementById('xeist-loading-reassure');
      if (!reassure) {
        reassure = document.createElement('div');
        reassure.id = 'xeist-loading-reassure';
        reassure.style.cssText = 'font-family: inherit; font-size: 13px; color: #666; margin-top: 14px;';
        reassure.textContent = 'Your design is saved — nothing was lost.';
        var card = document.getElementById('xeist-loading-card');
        if (card) card.appendChild(reassure);
      }

      var actions = document.getElementById('xeist-loading-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.id = 'xeist-loading-actions';
        actions.style.cssText = 'display:flex; gap:12px; margin-top:20px;';

        var retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = 'Try Again';
        retry.style.cssText = 'flex:1; min-height:48px; border:none; border-radius:10px; background:#5E2394; color:#fff; font-size:15px; font-weight:600; cursor:pointer;';
        retry.addEventListener('click', function () {
          /* Never re-add blind: if the original submission landed while the
             error was on screen, retrying would put a SECOND identical line
             in the cart and the coach would pay twice. */
          retry.disabled = true;
          retry.textContent = 'Checking\u2026';
          cartGrewSinceSubmit().then(function (grew) {
            if (grew) { redirectToCart(); return; }
            retry.disabled = false;
            retry.textContent = 'Try Again';
            removeOverlay();
            state.isSubmitting = false;
            handleSubmit();
          });
        });

        var close = document.createElement('button');
        close.type = 'button';
        close.textContent = 'Close';
        close.style.cssText = 'flex:1; min-height:48px; border:1px solid #ccc; border-radius:10px; background:#fff; color:#1a1a1a; font-size:15px; font-weight:600; cursor:pointer;';
        close.addEventListener('click', function () {
          removeOverlay();
          state.isSubmitting = false;
          render();
        });

        actions.appendChild(retry);
        actions.appendChild(close);
        var card2 = document.getElementById('xeist-loading-card');
        if (card2) card2.appendChild(actions);
      }
    } else {
      removeOverlay();
    }

    function removeOverlay() {
      if (!loadingOverlay) return;
      if (loadingOverlay.parentNode) loadingOverlay.parentNode.removeChild(loadingOverlay);
      loadingOverlay = null;
    }
  }

  var lastSubmitTime = 0;
  var SUBMIT_STUCK_MS = 60000; // 60s — if isSubmitting is still true, force-reset

  function handleSubmit() {
    // Safety valve: if a previous submit got stuck (e.g. KitBuilder froze and
    // hash routing prevented a full page reload), allow re-submission.
    if (state.isSubmitting && lastSubmitTime && (Date.now() - lastSubmitTime > SUBMIT_STUCK_MS)) {
      console.warn('[Xeist Coach Panel] isSubmitting was stuck for >' + (SUBMIT_STUCK_MS / 1000) + 's — resetting');
      state.isSubmitting = false;
      dismissLoadingOverlay();
    }
    if (!bridge || state.isSubmitting) return;

    state.hasAttemptedSubmit = true;
    state.syncError = null;
    updateValidationFromBridge();
    render();

    if (!getLocalValidation().valid) {
      /* Not a dead click: the note shows the reason and pulses. */
      pulseQtyAttention();
      return;
    }

    if (!state.bridgeReady) {
      return; /* note already reads "Preparing your customizer…" */
    }

    /* NOTE: a previous version also bailed out while state.isSyncing was
       true, which silently swallowed clicks at valid quantities. The
       queueBridgeSync() chain below already serialises any in-flight sync
       ahead of addToCart(), so submitting during a sync is safe. */

    /* Tell the cart page whether to attach the Downpay 35%-deposit selling
       plan to the KitBuilder line. (Percent CONFIRMED 35 by Justin
       2026-08-31 — the old 50% here was stale.) Written on EVERY submit (including '0')
       so a stale flag from an abandoned attempt can't misapply a deposit. */
    try {
      lsSet(DEPOSIT_APPLY_KEY, JSON.stringify({
        want: !!state.depositSelected,
        ts: Date.now()
      }));
    } catch (e) { /* private browsing — deposit falls back to pay-in-full */ }

    state.isSubmitting = true;
    lastSubmitTime = Date.now();
    submitStartedAt = Date.now();
    kbConsoleRing.length = 0;   /* fresh capture window per submit */
    /* Baseline the cart BEFORE the handoff so a lost redirect can later be
       told apart from a failed add (see startCartHandoffWatchdog). */
    captureCartBaseline();
    render();
    showLoadingOverlay();

    // Give the browser a paint frame to render the overlay before the
    // heavy KitBuilder checkout work blocks the main thread.
    // Without this delay, the overlay DOM exists but never paints.
    setTimeout(function () {

    queueBridgeSync().then(function () {
      updateValidationFromBridge();
      render();

      if (!(state.validation && state.validation.valid)) {
        state.isSubmitting = false;
        render();
        dismissLoadingOverlay('Validation failed \u2014 please review your order');
        return { ok: false };
      }

      return bridge.addToCart();
    }).then(function (result) {
      if (!result || result.ok === false) {
        dismissLoadingOverlay(result ? 'Something went wrong \u2014 please try again' : null);
        return;
      }
      if (!result.ok) {
        state.isSubmitting = false;
        state.syncError = getResultMessage(result);
        updateValidationFromBridge();
        render();
        dismissLoadingOverlay(getResultMessage(result));
        return;
      }

      // addToCart returned ok — the webhook callback + cart handoff is now
      // in progress asynchronously.  Do NOT call completeLoadingOverlay()
      // here — bridge.addToCart() returns almost immediately after triggering
      // the native KitBuilder checkout, but the actual Shopify cart handoff
      // (webhook callback → /cart/add.js → redirect) takes 15-30s.
      // The overlay keeps animating at the ~92% ceiling, always showing
      // movement, until the page redirects to /cart (which naturally
      // dismisses it).  completeLoadingOverlay() is only called from the
      // bridge right before the redirect fires.
      //
      // Watchdog: if the redirect never happens (KitBuilder's async handoff
      // can fail silently in its cross-origin bundle — observed as
      // "Error adding to cart" in console with no callback), turn the infinite
      // spinner into an actionable error instead of stranding the customer.
      startCartHandoffWatchdog();

      state.isSubmitting = false;
      state.syncError = null;
      render();
    }).catch(function (error) {
      state.isSubmitting = false;
      state.syncError = getResultMessage(error);
      updateValidationFromBridge();
      render();
      dismissLoadingOverlay(getResultMessage(error));
    });

    }, 300); // end setTimeout — 300ms ensures the browser paints the overlay
            // before KitBuilder's heavy checkout work blocks the main thread
  }

  function bindEvents() {
    if (els.uploadLogo) {
      els.uploadLogo.addEventListener('click', handleUploadLogo);
    }

    if (els.qtyDown) {
      els.qtyDown.addEventListener('click', function () {
        handleQuantityChange(state.quantity - 1);
      });
    }

    if (els.qtyUp) {
      els.qtyUp.addEventListener('click', function () {
        handleQuantityChange(state.quantity + 1);
      });
    }

    if (els.bottomBarQtyDown) {
      els.bottomBarQtyDown.addEventListener('click', function () {
        handleQuantityChange(state.quantity - 1);
      });
    }

    if (els.bottomBarQtyUp) {
      els.bottomBarQtyUp.addEventListener('click', function () {
        handleQuantityChange(state.quantity + 1);
      });
    }

    /* Typed input drives the FULL pipeline live (tier price, subtotal,
       validation message, CTA state, debounced KitBuilder sync) — no +/-
       press required. Empty or partial input ("e", "-") leaves state alone
       until blur, when handleQuantityChange restores/normalizes. */
    function onQtyTyped(event) {
      var raw = String(event.target.value || '').trim();
      var parsed = toInt(raw, NaN);
      if (raw === '' || !isFinite(parsed)) {
        render();
        return;
      }
      state.quantity = Math.min(maxQty, Math.max(1, parsed));
      state.hasUnsyncedChanges = true;
      state.syncError = null;
      render();
      scheduleSync(250);
    }

    if (els.qtyInput) {
      els.qtyInput.addEventListener('change', function (event) {
        handleQuantityChange(event.target.value);
      });
      els.qtyInput.addEventListener('input', onQtyTyped);
      els.qtyInput.addEventListener('blur', function (event) {
        handleQuantityChange(event.target.value);
      });
    }

    if (els.bottomBarQtyInput) {
      els.bottomBarQtyInput.addEventListener('change', function (event) {
        handleQuantityChange(event.target.value);
      });
      els.bottomBarQtyInput.addEventListener('input', onQtyTyped);
      els.bottomBarQtyInput.addEventListener('blur', function (event) {
        handleQuantityChange(event.target.value);
      });
    }

    function onPayModeChange() {
      state.depositSelected = !!(els.payModeDeposit && els.payModeDeposit.checked);
      try {
        lsSet(DEPOSIT_PREF_KEY, state.depositSelected ? '1' : '0');
      } catch (e) { /* noop */ }
      render();
    }
    if (els.payModeFull) els.payModeFull.addEventListener('change', onPayModeChange);
    if (els.payModeDeposit) els.payModeDeposit.addEventListener('change', onPayModeChange);

    if (els.cta) {
      els.cta.addEventListener('click', handleSubmit);
    }

    /* Wire bottom bar CTA to same submit handler */
    if (els.bottomBarCta) {
      els.bottomBarCta.addEventListener('click', handleSubmit);
    }

    window.addEventListener('resize', function () {
      ensureMounted();
    });
  }

  function init() {
    bindEvents();
    render();

    if (!bindBridge()) {
      bridgePoll = window.setInterval(function () {
        if (bindBridge()) {
          window.clearInterval(bridgePoll);
          bridgePoll = null;
        }
      }, 300);
    }

    mountPoll = window.setInterval(function () {
      if (state.bridgeReady) {
        ensureMounted();
      }
    }, 900);

    /* Re-render when floating buttons toggle number/logo */
    window.addEventListener('xeist:customization-changed', function () {
      render();
    });
    /* Also poll for editor changes (catches async Angular digests) */
    window.setInterval(function () {
      if (state.bridgeReady) render();
    }, 800);
  }

  /* ───────────────── Size step / Step 2 (2026-06-23) ─────────────────
     Jacket-only (SIZE_MODE). Two-step flow: Step 1 is the 3D design — the
     bottom bar is decluttered to a single "Continue to add sizes" button.
     Step 2 is a full overlay sheet (light, readable, roomy) where the coach
     enters per-size quantities (Adult Men's/Women's toggle + unisex Youth),
     sees live pricing, picks pay-in-full or deposit, and adds to cart. Add to
     Cart reuses the hidden bottom-bar CTA so the whole submit/handoff pipeline
     is unchanged; sizeMap/sizeBreakdown (flushed by queueBridgeSync at submit)
     carry the per-size split to KitBuilder and the cart line. */
  function setupSizeStep() {
    if (!SIZE_MODE) return;
    var sizeCfg = config.sizeEntry || {};
    var pricingCfg = config.pricing || {};
    var fx = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
    var barInner = document.querySelector('.xeist-bottom-bar__inner');
    var realCta = document.querySelector('[data-bottom-bar-cta]');
    if (!barInner) return;

    var rules = (sizeCfg.labelRules || []).map(function (r) { return { re: new RegExp(r.match), group: r.group, gender: r.gender || null }; });
    function classify(label) { for (var i = 0; i < rules.length; i++) { if (rules[i].re.test(label)) return rules[i]; } return { group: 'adult', gender: null }; }
    function shortLabel(l) { return String(l).replace(/^(Men's|Women's|Youth)\s+/, ''); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

    var qty = {}, labelById = {}, adult = {}, adultGenders = [], youth = [], hasGenders = false;
    var gender = sizeCfg.defaultGender || null;
    var payMode = 'full';
    var modelBuilt = false;

    var style = document.createElement('style');
    style.textContent =
      'body.xeist-sizes-mode [data-bottom-bar-quantity],body.xeist-sizes-mode .xeist-bottom-bar__payment,body.xeist-sizes-mode .xeist-bottom-bar__metric,body.xeist-sizes-mode .xeist-bottom-bar__tiernudge,body.xeist-sizes-mode .xeist-bottom-bar__roster,body.xeist-sizes-mode [data-bottom-bar-cta]{display:none !important;}'
      + '#xeist-continue-sizes{display:inline-flex;align-items:center;justify-content:center;gap:8px;flex:1 1 100%;width:100%;background:#6c2bd9;color:#fff;border:none;font-size:16px;font-weight:600;padding:15px 20px;border-radius:12px;cursor:pointer;}'
      + '#xeist-continue-sizes:disabled{opacity:.5;cursor:default;}'
      + '#xeist-size-overlay{position:fixed;inset:0;z-index:100000;background:rgba(15,10,25,.55);display:flex;align-items:flex-end;justify-content:center;opacity:0;pointer-events:none;transition:opacity .2s ease;}'
      + '#xeist-size-overlay.is-open{opacity:1;pointer-events:auto;}'
      + '#xeist-size-sheet{background:#fff;color:#140b21;width:100%;max-width:720px;max-height:92vh;overflow:auto;border-radius:18px 18px 0 0;padding:18px 20px 22px;box-shadow:0 -10px 50px rgba(0,0,0,.32);font-family:inherit;}'
      + '@media(min-width:760px){#xeist-size-overlay{align-items:center;}#xeist-size-sheet{border-radius:18px;}}'
      + '.xss-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:4px;}'
      + '.xss-ey{font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#8a7fa6;}'
      + '.xss-title{font-size:20px;font-weight:600;margin:2px 0 0;color:#140b21;}'
      + '.xss-close{width:34px;height:34px;border-radius:50%;border:1px solid #e1dcef;background:#fff;color:#5c5470;font-size:18px;cursor:pointer;line-height:1;flex:none;}'
      + '.xss-secrow{display:flex;align-items:center;gap:10px;margin:16px 0 8px;}'
      + '.xss-sec{font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.05em;color:#8a7fa6;}'
      + '.xss-sum{margin-left:auto;font-size:12px;color:#9a90b0;}'
      + '.xss-toggle{display:inline-flex;background:#f1eef8;border:1px solid #e7e3f2;border-radius:9px;padding:3px;}'
      + '.xss-gbtn{font-size:14px;border:none;padding:6px 16px;border-radius:7px;cursor:pointer;background:transparent;color:#5c5470;font-weight:500;}'
      + '.xss-gbtn.on{background:#6c2bd9;color:#fff;}'
      + '.xss-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;}'
      + '.xss-cell{display:flex;align-items:center;justify-content:space-between;gap:8px;background:#f7f5fc;border:1px solid #ece8f6;border-radius:10px;padding:7px 10px;}'
      + '.xss-cell .l{font-size:14px;font-weight:500;color:#3a3147;}'
      + '.xss-step{width:28px;height:28px;border-radius:8px;border:1px solid #ddd6ee;background:#fff;color:#140b21;font-size:17px;line-height:1;cursor:pointer;}'
      + '.xss-input{width:48px;height:34px;text-align:center;font-size:15px;border:1px solid #ddd6ee;border-radius:8px;background:#fff;color:#140b21;}'
      + '.xss-foot{margin-top:18px;border-top:1px solid #efecf7;padding-top:14px;}'
      + '.xss-metrics{display:flex;align-items:flex-end;gap:18px;flex-wrap:wrap;}'
      + '.xss-metric .k{font-size:12px;color:#8a7fa6;}'
      + '.xss-metric .v{font-size:22px;font-weight:600;color:#140b21;}'
      + '.xss-nudge{font-size:13px;color:#6f6685;margin:10px 0 0;min-height:18px;}'
      + '.xss-pay{display:flex;gap:8px;margin:12px 0;}'
      + '.xss-pay label{display:flex;align-items:center;gap:7px;font-size:14px;color:#3a3147;border:1px solid #e7e3f2;border-radius:10px;padding:9px 12px;cursor:pointer;flex:1;}'
      + '.xss-pay label.on{border-color:#6c2bd9;background:#f3edfd;}'
      + '.xss-addcta{width:100%;background:#6c2bd9;color:#fff;border:none;font-size:16px;font-weight:600;padding:14px;border-radius:12px;cursor:pointer;}'
      + '.xss-addcta:disabled{opacity:.45;cursor:not-allowed;}';
    document.head.appendChild(style);
    document.body.classList.add('xeist-sizes-mode');

    var cont = document.createElement('button');
    cont.id = 'xeist-continue-sizes';
    cont.type = 'button';
    cont.disabled = true;
    cont.textContent = 'Loading sizes…';
    barInner.appendChild(cont);
    cont.addEventListener('click', openOverlay);

    var overlay = document.createElement('div');
    overlay.id = 'xeist-size-overlay';
    overlay.innerHTML = '<div id="xeist-size-sheet" role="dialog" aria-modal="true" aria-label="Add team sizes"></div>';
    document.body.appendChild(overlay);
    var sheet = overlay.querySelector('#xeist-size-sheet');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay(); });

    function openOverlay() { if (!modelBuilt) return; seedFromBridge(); render(); overlay.classList.add('is-open'); maybeOfferCarriedSizes(); }
    function closeOverlay() { overlay.classList.remove('is-open'); }

    function buildModel() {
      var opts = window.XeistKBBridge.getSizeOptions();
      if (!opts || !opts.length) return false;
      opts.forEach(function (o) {
        labelById[o.id] = o.label;
        if (qty[o.id] == null) qty[o.id] = 0;
        var c = classify(o.label);
        if (c.group === 'youth') { youth.push(o); return; }
        var g = c.gender || '_none';
        if (c.gender) hasGenders = true;
        if (!adult[g]) { adult[g] = []; adultGenders.push(g); }
        adult[g].push(o);
      });
      if (hasGenders && (!gender || !adult[gender])) gender = adultGenders.filter(function (g) { return g !== '_none'; })[0] || adultGenders[0];
      modelBuilt = true;
      return true;
    }
    function seedFromBridge() {
      try { var ctx = window.XeistKBBridge.getContext(); (ctx.sizes || []).forEach(function (s) { qty[s.id] = Math.max(0, parseInt(s.quantity, 10) || 0); }); } catch (e) { /* noop */ }
      recompute();
    }

    function total() { var t = 0; for (var k in qty) { t += qty[k] || 0; } return t; }
    function tierPrice(t) { var ts = pricingCfg.baseTiers || []; for (var i = 0; i < ts.length; i++) { if (t >= ts[i].min && (ts[i].max == null || t <= ts[i].max)) return ts[i].unitPrice; } return ts.length ? ts[ts.length - 1].unitPrice : 0; }
    function nextTier(t) { var ts = pricingCfg.baseTiers || []; var cur = tierPrice(Math.max(t, 1)); for (var i = 0; i < ts.length; i++) { if (ts[i].min > t && ts[i].unitPrice < cur) return ts[i]; } return null; }
    function logoOn() { try { return !!window.XeistKBBridge.hasLogo(); } catch (e) { return false; } }
    function unitUsd(t) { return tierPrice(Math.max(t, 1)) + (logoOn() ? (pricingCfg.logoUpcharge || 0) : 0); }

    function recompute() {
      var map = {}, parts = [];
      adultGenders.forEach(function (g) { (adult[g] || []).forEach(function (o) { if (qty[o.id] > 0) { map[o.id] = qty[o.id]; parts.push(labelById[o.id] + ' ×' + qty[o.id]); } }); });
      youth.forEach(function (o) { if (qty[o.id] > 0) { map[o.id] = qty[o.id]; parts.push(labelById[o.id] + ' ×' + qty[o.id]); } });
      sizeMap = map;
      sizeBreakdown = parts.length ? parts.join(' · ') : null;
    }

    function cell(o) {
      return '<div class="xss-cell"><span class="l">' + esc(shortLabel(o.label)) + '</span>'
        + '<span style="display:flex;align-items:center;gap:5px;">'
        + '<button type="button" class="xss-step" data-act="dec" data-id="' + esc(o.id) + '" aria-label="Decrease ' + esc(o.label) + '">−</button>'
        + '<input class="xss-input" type="number" min="0" inputmode="numeric" value="' + (qty[o.id] || 0) + '" data-id="' + esc(o.id) + '" aria-label="' + esc(o.label) + ' quantity">'
        + '<button type="button" class="xss-step" data-act="inc" data-id="' + esc(o.id) + '" aria-label="Increase ' + esc(o.label) + '">+</button>'
        + '</span></div>';
    }
    function gridHtml(list) { return '<div class="xss-grid">' + list.map(cell).join('') + '</div>'; }
    function sumIds(list) { var t = 0; (list || []).forEach(function (o) { t += qty[o.id] || 0; }); return t; }

    /* v15: single source of truth for every computed string/number the sheet
       shows, shared by the full render() and the keystroke-path patcher
       updateTotalsLive() so the two can't drift. */
    function summaryModel() {
      var t = total();
      var unit = unitUsd(t) * fx;
      var sub = unit * t;
      var minQ = (config.rules && config.rules.minQty) || 1;
      var nounS = config.productNoun || 'item';
      var nounP = config.productNounPlural || 'items';
      var nudge = '';
      if (t < minQ) { var need = minQ - t; nudge = 'Add ' + need + ' more ' + (need === 1 ? nounS : nounP) + ' to meet the ' + minQ + '-' + nounS + ' minimum.'; }
      else { var nt = nextTier(t); if (nt) { nudge = 'Add ' + (nt.min - t) + ' more for ' + money((nt.unitPrice + (logoOn() ? (pricingCfg.logoUpcharge || 0) : 0)) * fx) + ' per ' + nounS + '.'; } else { nudge = 'Best volume price unlocked.'; } }
      var dep = sub * ((pricingCfg.depositPercent || 0) / 100);
      var asum = [];
      adultGenders.forEach(function (g) { if (g !== '_none' && adult[g].length) asum.push(g + ' ' + sumIds(adult[g])); });
      return {
        t: t, unit: unit, sub: sub, dep: dep, minQ: minQ, nounS: nounS, nounP: nounP,
        nudge: nudge,
        asum: asum.join(' · '),
        ysum: 'Youth ' + sumIds(youth),
        payFullText: 'Pay in full · ' + money(sub),
        payDepText: 'Pay ' + (pricingCfg.depositPercent || 0) + '% · ' + money(dep) + ' today',
        ctaDisabled: t < minQ,
        ctaText: (t < minQ) ? 'Add sizes to continue' : 'Add to cart · ' + money(payMode === 'deposit' ? dep : sub)
      };
    }

    function render() {
      var s = summaryModel();
      var html = '';
      html += '<div class="xss-head"><div><div class="xss-ey">Step 2 of 2 · ' + esc(config.orderTitle || 'Order') + '</div><h2 class="xss-title">Add team sizes</h2></div><button type="button" class="xss-close" data-close aria-label="Back to design">×</button></div>';
      var activeAdult = hasGenders ? (adult[gender] || []) : (adult['_none'] || []);
      if (activeAdult.length || hasGenders) {
        var toggle = '';
        if (hasGenders) {
          var gs = adultGenders.filter(function (g) { return g !== '_none' && adult[g].length; });
          toggle = '<div class="xss-toggle">' + gs.map(function (g) { return '<button type="button" class="xss-gbtn ' + (g === gender ? 'on' : '') + '" data-g="' + esc(g) + '">' + esc(g) + '</button>'; }).join('') + '</div>';
        }
        html += '<div class="xss-secrow"><span class="xss-sec">Adult</span>' + toggle + '<span class="xss-sum">' + esc(s.asum) + '</span></div>' + gridHtml(activeAdult);
      }
      if (youth.length) {
        html += '<div class="xss-secrow"><span class="xss-sec">Youth · unisex</span><span class="xss-sum">' + esc(s.ysum) + '</span></div>' + gridHtml(youth);
      }
      html += '<div class="xss-foot"><div class="xss-metrics">'
        + '<div class="xss-metric"><div class="k">Total ' + esc(s.nounP) + '</div><div class="v">' + s.t + '</div></div>'
        + '<div class="xss-metric"><div class="k">Cost per ' + esc(s.nounS) + '</div><div class="v">' + money(s.unit) + '</div></div>'
        + '<div class="xss-metric" style="margin-left:auto;text-align:right;"><div class="k">Subtotal</div><div class="v">' + money(s.sub) + '</div></div>'
        + '</div>';
      html += '<p class="xss-nudge">' + esc(s.nudge) + '</p>';
      html += '<div class="xss-pay">'
        + '<label class="' + (payMode === 'full' ? 'on' : '') + '"><input type="radio" name="xss-pay" value="full" ' + (payMode === 'full' ? 'checked' : '') + '> <span class="xss-pay-t">' + s.payFullText + '</span></label>'
        + '<label class="' + (payMode === 'deposit' ? 'on' : '') + '"><input type="radio" name="xss-pay" value="deposit" ' + (payMode === 'deposit' ? 'checked' : '') + '> <span class="xss-pay-t">' + s.payDepText + '</span></label>'
        + '</div>';
      html += '<button type="button" class="xss-addcta" data-add ' + (s.ctaDisabled ? 'disabled' : '') + '>' + s.ctaText + '</button>';
      html += '</div>';
      sheet.innerHTML = html;
    }

    /* v15: keystroke path — patch only the nodes whose content changed. No
       innerHTML rebuild, so the focused input (and its caret) survive and the
       browser does zero re-parse/re-layout of the grid. */
    function updateTotalsLive() {
      var s = summaryModel();
      var vs = sheet.querySelectorAll('.xss-metric .v');
      if (vs.length >= 3) { vs[0].textContent = s.t; vs[1].textContent = money(s.unit); vs[2].textContent = money(s.sub); }
      var sums = sheet.querySelectorAll('.xss-sum');
      var si = 0;
      var activeAdult = hasGenders ? (adult[gender] || []) : (adult['_none'] || []);
      if (activeAdult.length || hasGenders) { if (sums[si]) sums[si].textContent = s.asum; si++; }
      if (youth.length && sums[si]) sums[si].textContent = s.ysum;
      var nud = sheet.querySelector('.xss-nudge');
      if (nud) nud.textContent = s.nudge;
      var payTs = sheet.querySelectorAll('.xss-pay-t');
      if (payTs.length >= 2) { payTs[0].textContent = s.payFullText; payTs[1].textContent = s.payDepText; }
      var cta = sheet.querySelector('.xss-addcta');
      if (cta) { cta.disabled = s.ctaDisabled; cta.textContent = s.ctaText; }
    }

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { closeOverlay(); return; }
      var gb = e.target.closest('[data-g]'); if (gb) { gender = gb.getAttribute('data-g'); render(); return; }
      var sb = e.target.closest('[data-act]'); if (sb) { var id = sb.getAttribute('data-id'); var cur = qty[id] || 0; setQty(id, sb.getAttribute('data-act') === 'inc' ? cur + 1 : cur - 1); return; }
      var add = e.target.closest('[data-add]'); if (add && !add.disabled) { submitFromOverlay(); return; }
    });
    sheet.addEventListener('input', function (e) { var inp = e.target.closest('.xss-input'); if (!inp) return; setQtyLive(inp.getAttribute('data-id'), inp.value); });
    sheet.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="xss-pay"]');
      if (r) { payMode = r.value; render(); return; }
      /* Normalize the edited size input's displayed value (e.g. "-3" → 0)
         with a full render once editing is committed. */
      if (e.target.closest('.xss-input')) render();
    });

    function setQty(id, v) { qty[id] = Math.max(0, parseInt(v, 10) || 0); recompute(); render(); }
    function setQtyLive(id, v) { qty[id] = Math.max(0, parseInt(v, 10) || 0); recompute(); updateTotalsLive(); }

    /* Track which designs have been added in this set-building session so we
       never offer (or card) an item that's already in the order — fixes the
       "complete the jacket → add joggers → it asks you to add the jacket again"
       loop. Entries expire after 2h so a later, unrelated order starts clean. */
    var ADDED_KEY = 'xeist_set_added';
    var ADDED_TTL = 2 * 60 * 60 * 1000;
    function readAdded() {
      var m = {};
      try { m = JSON.parse(lsGet(ADDED_KEY) || '{}') || {}; } catch (e) { m = {}; }
      var now = Date.now();
      for (var d in m) { if (!(m.hasOwnProperty(d) && (now - m[d]) < ADDED_TTL)) delete m[d]; }
      return m;
    }
    function markDesignAdded(id) {
      if (!id) return;
      try { var m = readAdded(); m[String(id)] = Date.now(); lsSet(ADDED_KEY, JSON.stringify(m)); } catch (e) { /* noop */ }
    }
    function isDesignAdded(id) {
      if (!id) return false;
      var m = readAdded();
      return !!m[String(id)];
    }

    /* ---- Size-run carry-over (v14) ----
       Stash this design's size breakdown at submit; offer it as a prefill when
       the coach opens the PAIRED design's size sheet. Keyed by size LABEL
       (e.g. "Men's L"), not KB size id — ids differ between designs while the
       16-size catalog labels match. The offer only appears when: the stash is
       fresh (2h), it came from this design's crossSell pair, the grid is still
       empty, this design isn't already in the order, and the coach hasn't
       already answered the prompt this session. */
    var CARRY_SIZES_KEY = 'xeist_carry_sizes';
    var CARRY_SIZES_TTL = 2 * 60 * 60 * 1000;
    function stashSizesForPair() {
      try {
        if (!SIZE_MODE) return;
        recompute();
        var sizes = [];
        for (var id in sizeMap) {
          if (sizeMap.hasOwnProperty(id) && sizeMap[id] > 0 && labelById[id]) {
            sizes.push({ label: labelById[id], qty: sizeMap[id] });
          }
        }
        if (!sizes.length) return;
        lsSet(CARRY_SIZES_KEY, JSON.stringify({
          from: String(config.designId || ''),
          title: String(config.orderTitle || '').replace(/\s+Order$/, ''),
          ts: Date.now(),
          sizes: sizes
        }));
      } catch (e) { /* noop */ }
    }
    function readCarriedSizes() {
      try {
        var raw = lsGet(CARRY_SIZES_KEY);
        if (!raw) return null;
        var s = JSON.parse(raw);
        if (!s || !s.sizes || !s.sizes.length) return null;
        if ((Date.now() - (s.ts || 0)) > CARRY_SIZES_TTL) return null;
        return s;
      } catch (e) { return null; }
    }
    function matchPromptAnswered() {
      try { return window.sessionStorage.getItem('xeist_match_sizes_' + config.designId) === '1'; } catch (e) { return false; }
    }
    function setMatchPromptAnswered() {
      try { window.sessionStorage.setItem('xeist_match_sizes_' + config.designId, '1'); } catch (e) { /* noop */ }
    }
    function applyCarriedSizes(stash) {
      var byLabel = {};
      for (var id in labelById) { if (labelById.hasOwnProperty(id)) byLabel[labelById[id]] = id; }
      var applied = 0;
      stash.sizes.forEach(function (s) {
        var id = byLabel[s.label];
        if (id != null) { qty[id] = Math.max(0, parseInt(s.qty, 10) || 0); applied++; }
      });
      /* Land the adult toggle on a gender that actually received quantities so
         the prefill is visible the moment the prompt closes. */
      if (hasGenders) {
        for (var i = 0; i < adultGenders.length; i++) {
          var g = adultGenders[i];
          if (g === '_none') continue;
          var any = false;
          (adult[g] || []).forEach(function (o) { if ((qty[o.id] || 0) > 0) any = true; });
          if (any) { gender = g; break; }
        }
      }
      recompute();
      return applied;
    }
    function maybeOfferCarriedSizes() {
      if (!SIZE_MODE || matchPromptAnswered()) return;
      if (total() > 0) return;                    /* grid already has sizes */
      if (isDesignAdded(config.designId)) return; /* editing an added item */
      var stash = readCarriedSizes();
      if (!stash) return;
      var pairId = config.crossSell && config.crossSell.designId;
      if (!pairId || String(stash.from) !== String(pairId)) return;
      showMatchSizesPrompt(stash);
    }
    function showMatchSizesPrompt(stash) {
      var ov = document.getElementById('xeist-match-sizes-prompt');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'xeist-match-sizes-prompt';
        ov.style.cssText = 'position:fixed;inset:0;z-index:100002;background:rgba(15,10,25,.55);display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity .2s ease;padding:18px;';
        ov.innerHTML = '<div id="xms-card" role="dialog" aria-modal="true" aria-label="Use the same sizes" style="background:#fff;color:#140b21;width:100%;max-width:440px;border-radius:18px;padding:22px;box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:inherit;"></div>';
        document.body.appendChild(ov);
      }
      function hide() { ov.style.opacity = '0'; ov.style.pointerEvents = 'none'; }
      var card = ov.querySelector('#xms-card');
      var totalQty = 0;
      stash.sizes.forEach(function (s) { totalQty += parseInt(s.qty, 10) || 0; });
      var breakdown = stash.sizes.map(function (s) { return esc(s.label) + ' ×' + s.qty; }).join(' · ');
      card.innerHTML =
        '<div style="font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#8a7fa6;font-weight:600;margin-bottom:4px;">Add team sizes</div>'
        + '<h2 style="font-size:21px;font-weight:600;margin:4px 0 4px;color:#140b21;">Use the same sizes?</h2>'
        + '<p style="font-size:14px;color:#6f6685;margin:0 0 14px;line-height:1.5;">Want these ' + esc(NOUN_PLURAL) + ' in the same sizes as your ' + esc(stash.title || 'matching item') + ' (' + totalQty + ' total)?</p>'
        + '<div style="font-size:13px;color:#3a3147;background:#f7f5fc;border:1px solid #ece8f6;border-radius:12px;padding:12px;margin-bottom:18px;line-height:1.6;">' + breakdown + '</div>'
        + '<button type="button" data-xms-yes style="width:100%;background:#6c2bd9;color:#fff;border:none;font-size:16px;font-weight:600;padding:14px;border-radius:12px;cursor:pointer;">Yes, match the sizes</button>'
        + '<button type="button" data-xms-no style="width:100%;background:transparent;color:#6f6685;border:none;font-size:14px;font-weight:500;padding:12px;margin-top:6px;cursor:pointer;">No, I&rsquo;ll enter them myself</button>';
      card.querySelector('[data-xms-yes]').onclick = function () {
        setMatchPromptAnswered();
        applyCarriedSizes(stash);
        render();
        hide();
      };
      card.querySelector('[data-xms-no]').onclick = function () {
        setMatchPromptAnswered();
        hide();
      };
      ov.style.opacity = '1';
      ov.style.pointerEvents = 'auto';
    }

    function submitFromOverlay() {
      recompute();
      /* Apply the deposit/full choice onto the hidden bar radios now, so the
         existing submit + deposit-apply logic picks it up whichever path runs. */
      var full = document.querySelector('[data-pay-mode-full]');
      var deposit = document.querySelector('[data-pay-mode-deposit]');
      var want = payMode === 'deposit' ? deposit : full;
      if (want && !want.checked) { want.checked = true; want.dispatchEvent(new Event('change', { bubbles: true })); }
      /* Matching-set upsell: offer the paired item ONLY if it isn't already in
         this order — otherwise the set is complete, so go straight to cart. */
      var cross = config.crossSell;
      if (cross && cross.designId && !isDesignAdded(cross.designId)) { showJoggersPrompt(cross); }
      else { doSubmit(); }
    }

    function hidePrompt() {
      var pr = document.getElementById('xeist-joggers-prompt');
      if (pr) { pr.style.opacity = '0'; pr.style.pointerEvents = 'none'; }
    }
    function doSubmit() {
      /* Stash the size run so the paired garment can offer "same sizes". */
      stashSizesForPair();
      /* This design is being added now — record it so its pair won't re-offer it. */
      markDesignAdded(config.designId);
      closeOverlay();
      hidePrompt();
      if (realCta) realCta.click();
    }

    /* "Add matching joggers?" prompt — shown over the size sheet at Add to cart.
       Yes: stash a logo-carry flag (so the joggers page re-places the uploaded
       logo) + set the post-add redirect to the joggers customizer, then submit
       the jacket. No: clear any redirect override and submit normally. */
    function showJoggersPrompt(cross) {
      var ov = document.getElementById('xeist-joggers-prompt');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'xeist-joggers-prompt';
        ov.style.cssText = 'position:fixed;inset:0;z-index:100001;background:rgba(15,10,25,.55);display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity .2s ease;padding:18px;';
        ov.innerHTML = '<div id="xjp-card" role="dialog" aria-modal="true" aria-label="Add matching joggers" style="background:#fff;color:#140b21;width:100%;max-width:440px;border-radius:18px;padding:22px;box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:inherit;"></div>';
        document.body.appendChild(ov);
        ov.addEventListener('click', function (e) { if (e.target === ov) { hidePrompt(); } });
      }
      var card = ov.querySelector('#xjp-card');
      var label = cross.label || 'the matching set';
      var orderName = (config.orderTitle || 'Order').replace(/ Order$/, '');
      card.innerHTML =
        '<div style="font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#1d9e75;font-weight:600;margin-bottom:4px;">' + orderName + ' ready</div>'
        + '<h2 style="font-size:21px;font-weight:600;margin:4px 0 4px;color:#140b21;">Complete the set?</h2>'
        + '<p style="font-size:14px;color:#6f6685;margin:0 0 16px;line-height:1.5;">We’ll open the ' + label + ' customizer with the logo you just uploaded already placed on the preview.</p>'
        + '<div style="display:flex;gap:12px;align-items:center;background:#f7f5fc;border:1px solid #ece8f6;border-radius:12px;padding:12px;margin-bottom:18px;">'
        + '<div id="xjp-img" style="width:60px;height:74px;border-radius:8px;background:#e4e0ee;flex:none;overflow:hidden;display:flex;align-items:center;justify-content:center;color:#9a90b0;font-size:10px;">Set</div>'
        + '<div><div style="font-size:15px;font-weight:600;">' + label + '</div><div style="font-size:13px;color:#6f6685;margin-top:2px;">Same logo carried over</div></div></div>'
        + '<button type="button" data-xjp-yes style="width:100%;background:#6c2bd9;color:#fff;border:none;font-size:16px;font-weight:600;padding:14px;border-radius:12px;cursor:pointer;">Yes, add these &rarr;</button>'
        + '<button type="button" data-xjp-no style="width:100%;background:transparent;color:#6f6685;border:none;font-size:14px;font-weight:500;padding:12px;margin-top:6px;cursor:pointer;">No thanks</button>';

      /* Show the paired product image: prefer a config asset (the black photos),
         else fetch the Shopify product photo by handle. */
      var imgBox = card.querySelector('#xjp-img');
      function setImg(src) { if (src && imgBox) imgBox.innerHTML = '<img src="' + src + '" alt="" onerror="this.parentNode.textContent=\'Set\'" style="width:100%;height:100%;object-fit:cover;">'; }
      if (cross.image) { setImg(cross.image); }
      else if (cross.handle) {
        fetch('/products/' + cross.handle + '.json').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          var src = d && d.product && ((d.product.image && d.product.image.src) || (d.product.images && d.product.images[0] && d.product.images[0].src));
          if (src) setImg(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160');
        }).catch(function () {});
      }

      card.querySelector('[data-xjp-yes]').onclick = function () {
        try {
          var b = window.XeistKBBridge;
          if (b && b.hasLogo && b.hasLogo().hasLogo) {
            lsSet('xeist_carry_logo', JSON.stringify({ want: true, ts: Date.now(), from: config.designId }));
          }
        } catch (e) { /* noop */ }
        /* Unique query forces a full navigation onto the paired design even on a
           chained add-the-set (where the current URL already carries ?addset). */
        window.__xeistPostAddRedirect = window.location.origin + '/pages/3d-customizer?addset=' + Date.now() + '#/customise/' + cross.designId;
        doSubmit();
      };
      card.querySelector('[data-xjp-no]').onclick = function () {
        try { window.__xeistPostAddRedirect = null; } catch (e) {}
        doSubmit();
      };

      ov.classList.add('is-open');
      ov.style.opacity = '1';
      ov.style.pointerEvents = 'auto';
    }

    var tries = 0;
    var boot = window.setInterval(function () {
      tries++;
      if (tries > 150) { window.clearInterval(boot); return; }
      if (!window.XeistKBBridge || typeof window.XeistKBBridge.getSizeOptions !== 'function') return;
      if (!buildModel()) return;
      window.clearInterval(boot);
      seedFromBridge();
      cont.disabled = false;
      cont.innerHTML = 'Continue to add sizes <span aria-hidden="true">→</span>';
    }, 350);
  }

  /* ───────────────── STEPPED FLOW (v17, Phase A) ─────────────────
     Gate order: URL override beats config; then viewport, product, mode.
     ?flow=classic forces the flat bar even when the config flag is on;
     ?flow=stepped forces stepped for testing before the flag flips. */
  /* Returns the layout to run ('sheet' <=768px fullscreen panels, 'rail'
     >768px right sidebar — phase F) or false. Defaults are per-viewport:
     stepped_flow (mobile, ON) / stepped_flow_desktop (OFF until the rail
     pass is approved). ?flow=stepped forces either; ?flow=classic kills
     both. */
  function steppedFlowActive() {
    try {
      var qs = String(window.location.search || '');
      if (/[?&]flow=classic(?:&|$)/.test(qs)) return false;
      var forced = /[?&]flow=stepped(?:&|$)/.test(qs);
      var layout = window.innerWidth > 768 ? 'rail' : 'sheet';
      var cfgOn = false;
      try {
        var v = (window.XeistConfig && window.XeistConfig.v) || {};
        cfgOn = layout === 'rail' ? !!v['stepped_flow_desktop'] : !!v['stepped_flow'];
      } catch (e) { /* noop */ }
      if (!forced && !cfgOn) return false;
      if (SIZE_MODE) return false;
      /* Backpacks only (one-size): Orbit + Dual Strap. */
      if (!/114891065|114890045/.test(String(window.location.hash || ''))) return false;
      return layout;
    } catch (e) { return false; }
  }

  /* ───────────────── STEPPED FLOW controller (Phase B) ─────────────────
     Steps: 0 Customize (live 3D + mini bar) · 1 Quantity · 2 Payment ·
     3 Review. All amounts come from the SAME engine as the flat bar:
     getSummary() (tiers + decoration upcharges + live FX + Markets whole-
     dollar rounding), pricing.depositPercent, handleQuantityChange()'s
     sync chain, and handleSubmit()'s overlay/watchdog. The flat bar stays
     in the DOM (hidden via html[data-xeist-flow=on]) so state.depositSelected
     and every existing listener keep working. Renders on a 800ms interval
     + after every local action — deliberately NOT patched into render().
     Payment is a deliberate choice: nothing preselected, Continue disabled
     until chosen (audit ruling; deposit-default is A/B #1). */
  var stepped = {
    active: false,
    layout: 'sheet',      /* 'sheet' (mobile fullscreen) | 'rail' (desktop sidebar) */
    step: 0,
    pay: null,            /* null | 'full' | 'dep' — no preselection */
    els: null,
    prevUnitUsd: null,    /* tier unit before the last qty change */
    flashDown: false,     /* show the crossed-down price note until next change */
    decoShown: false,     /* no-decoration interstitial shown once */
    lastQtyMethod: null,  /* 'stepper' | 'typed' — rides on quantity_continue */
    interval: null
  };
  /* Phase E funnel: v17 emits CustomEvents; module 29 forwards them to
     XeistTrack as flow_<type>. Decoupled so this asset never needs the
     session stack to exist. once=true -> once per pageview. */
  var flowOnce = {};
  function steppedTrack(type, payload, once) {
    if (once) { if (flowOnce[type]) return; flowOnce[type] = true; }
    try {
      window.dispatchEvent(new CustomEvent('xeist:flow-event', { detail: Object.assign({ type: type, layout: stepped.layout }, payload || {}) }));
    } catch (e) { /* noop */ }
  }

  var STEPPED_STATE_KEY = 'xeist_stepped_v1_' + String((window.location.hash || '').match(/customise\/(\d+)/) ? (window.location.hash || '').match(/customise\/(\d+)/)[1] : 'x');

  function steppedPersist() {
    try { lsSet(STEPPED_STATE_KEY, JSON.stringify({ step: stepped.step, pay: stepped.pay, qty: state.quantity, deco: stepped.decoShown ? 1 : 0 })); } catch (e) { /* noop */ }
  }
  function steppedRestore() {
    try {
      var raw = lsGet(STEPPED_STATE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (!saved) return;
      if (saved.pay === 'full' || saved.pay === 'dep' || saved.pay === 'par') stepped.pay = saved.pay;
      var st = toInt(saved.step, 0);
      if (st >= 0 && st <= 3) stepped.step = st;
      var q = toInt(saved.qty, NaN);
      if (isFinite(q) && q >= 1) state.quantity = Math.min(maxQty, q);
      stepped.decoShown = !!saved.deco;
    } catch (e) { /* noop */ }
    if (stepped.pay === null && stepped.step > 2) stepped.step = 2;
    /* Parents pay has no Review step (2026-09-16): a session saved on
       step 3 in par mode reopens on Payment, where the link CTA lives. */
    if (stepped.pay === 'par' && stepped.step > 2) stepped.step = 2;
    /* A/B hook (test #1: deposit-default vs none): ?paydefault=dep|full
       preselects for coaches with no stored choice. Driven by the URL so
       an A/B tool or campaign link can set the arm without a theme push. */
    try {
      var pd = /[?&]paydefault=(dep|full)(?:&|$)/.exec(String(window.location.search || ''));
      if (pd && stepped.pay === null) {
        stepped.pay = pd[1];
        steppedTrack('payment_defaulted', { method: pd[1] });
      }
    } catch (e) { /* noop */ }
  }

  function steppedPresentUnit(tierUnitUsd) {
    /* Ladder/display price for a tier at the CURRENT decoration, in
       presentment currency. Mirrors getSummary()'s per-unit math. */
    var usd = toNumber(tierUnitUsd, 0);
    if (hasLogoSelectionLocal()) usd += toNumber(pricing.logoUpcharge, 0);
    if (hasNumberSelection()) usd += toNumber(pricing.numberUpcharge, 0);
    return usd * presentmentRate();
  }

  /* Step 2 price focus (2026-09-16; replaces steppedTierNote + the order
     total line). The per-unit price is the headline of the quantity step
     and the ONE nudge under it is the next price break: how many more, the
     new per-unit price, the per-unit saving and a progress bar toward the
     break. No order total on this step (Review has it) and no tier table —
     one choice on the screen. The card goes quiet (is-down) right after a
     downward crossing (same trigger as the old note) and turns into a
     one-line "Best team price" confirmation on the top level.
     Prices: the headline is summary.unitPrice (what is actually charged
     per unit at this quantity); the next level is steppedUnitAt(level,
     level.min) — the same getSummary() math (decoration upcharges, live
     FX, Markets' whole-dollar rounding of the line total), so "1 more bag
     -> $60.12" at 24 is exactly the headline the coach sees at 25, and the
     saving is the difference between the two numbers on screen. */
  function steppedUnitAt(tier, q) {
    var usd = toNumber(tier.unitPrice, 0);
    if (hasLogoSelectionLocal()) usd += toNumber(pricing.logoUpcharge, 0);
    if (hasNumberSelection()) usd += toNumber(pricing.numberUpcharge, 0);
    var fx = presentmentRate();
    var sub = usd * q * fx;
    if (fx !== 1) sub = Math.round(sub);
    return q > 0 ? sub / q : 0;
  }

  function steppedPriceFocus(summary) {
    var els2 = stepped.els;
    var tiers = getConfiguredTiers();
    var qty = summary.quantity;
    var current = getTierForQuantity(qty);
    var next = summary.nextTier;
    var curUnit = summary.unitPrice;

    /* headline: the per-unit price */
    if (els2.eachAmt) els2.eachAmt.textContent = formatMoney(curUnit);
    if (els2.eachUnit) els2.eachUnit.textContent = 'a ' + NOUN;
    if (!els2.eachAmt && els2.each) els2.each.textContent = formatMoney(curUnit) + ' a ' + NOUN;

    if (!els2.next) return;
    var reachable = 0; /* levels the coach can actually land on (>= minQty) */
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].max === null || tiers[i].max >= minQty) reachable++;
    }
    var multi = reachable > 1;
    els2.next.classList.remove('is-down', 'is-top');
    if (multi && next) {
      var nextUnit = steppedUnitAt(next, next.min);
      var more = Math.max(1, next.min - qty);
      var save = Math.max(0, curUnit - nextUnit);
      var lo = Math.max(current.min, minQty);
      var pct = Math.max(0, Math.min(1, (qty - lo) / Math.max(1, next.min - lo)));
      if (stepped.flashDown) els2.next.classList.add('is-down');
      if (els2.nextLine) els2.nextLine.textContent = more + ' more ' + (more === 1 ? NOUN : NOUN_PLURAL) + ' \u2192 ' + formatMoney(nextUnit) + ' a ' + NOUN;
      if (els2.nextSave) { els2.nextSave.textContent = 'Save ' + formatMoney(save) + ' a ' + NOUN; els2.nextSave.hidden = false; }
      if (els2.nextFill) els2.nextFill.style.width = Math.round(pct * 100) + '%';
      if (els2.nextBar) els2.nextBar.hidden = false;
      els2.next.hidden = false;
    } else if (multi) {
      /* top level: nothing left to unlock */
      els2.next.classList.add('is-top');
      if (els2.nextLine) els2.nextLine.textContent = 'Best team price';
      if (els2.nextSave) els2.nextSave.hidden = true;
      if (els2.nextBar) els2.nextBar.hidden = true;
      els2.next.hidden = false;
    } else {
      els2.next.hidden = true;
    }
  }

  function steppedDepositAmounts(summary) {
    var pct = toNumber(pricing.depositPercent, 35);
    var dep = Math.round(summary.subtotal * pct) / 100;
    var rem = Math.round((summary.subtotal - dep) * 100) / 100;
    return { pct: pct, dep: dep, rem: rem };
  }

  /* Phase C fix (post-push, Justin's phone pass): the canvas only filled
     the top half of the locked viewport, leaving a dead band above the mini
     bar. Same cure module 13 applies on DESKTOP (centerPreviewBag): size
     the canvas to the live band, zoom, and center via translateY on the
     panel inner — re-applied every heartbeat because KB's Angular digests
     wipe inline transforms (read the LIVE style, self-healing). Runs only
     on step 0; module 13 no-ops under 990px so there is no fight. */
  function steppedCenterBag() {
    /* sheet: only step 0 (panels cover the canvas on 1-3). rail: the bag
       stays visible beside the rail on every step. */
    if (stepped.layout !== 'rail' && stepped.step !== 0) return;
    var previewPanel = document.querySelector('.kb-preview-panel');
    if (!previewPanel) return;
    var inner = previewPanel.querySelector('.kb-preview-panel-inner');
    var canvas = previewPanel.querySelector('canvas');
    if (!inner || !canvas) return;
    var bandTop = 68; /* sheet: below the save/share icon */
    if (stepped.layout === 'rail') {
      /* desktop keeps the site header — start the band under it */
      bandTop = 24;
      try {
        var hdr = document.querySelector('header');
        if (hdr) {
          var hr = hdr.getBoundingClientRect();
          if (hr.bottom > 0 && hr.bottom < window.innerHeight * 0.5) bandTop = hr.bottom + 12;
        }
      } catch (e) { /* noop */ }
    }
    var mb = stepped.els && stepped.els.minibar;
    var mbRect = (mb && !mb.hidden) ? mb.getBoundingClientRect() : null;
    var bandBottom = (mbRect && mbRect.height) ? mbRect.top
      : (stepped.layout === 'rail' ? window.innerHeight - 24 : window.innerHeight - 100);
    var bandHeight = Math.max(220, Math.round(bandBottom - bandTop) - 16);
    var panelRect = previewPanel.getBoundingClientRect();
    var cfg2 = window.XeistOrbitCoachConfig || {};
    var zs = (typeof cfg2.previewZoomScale === 'number' && isFinite(cfg2.previewZoomScale) && cfg2.previewZoomScale > 0) ? cfg2.previewZoomScale : 1;
    var ZOOM = (stepped.layout === 'rail' ? 1.8 : 1.24) * zs; /* sheet 1.24 tuned on Justin's phone; rail starts near the classic desktop 2.0, minus rail crowding */
    /* Applied EVERY beat (identical values are a no-op to layout): a memo
       guard let a one-time wipe by another module stick permanently.
       HEIGHT, not just max-height: KB lays the panel out ~292px tall on
       mobile and max-height never GROWS an element — overflow:hidden then
       clipped the scaled canvas at the panel's natural bottom (the
       cut-in-half bag, 2026-08-31). Explicit height makes the panel span
       the whole band so the clip edges are the band edges. */
    var panelH = Math.max(220, Math.round(bandBottom - panelRect.top) - 8);
    previewPanel.style.setProperty('height', panelH + 'px', 'important');
    previewPanel.style.setProperty('max-height', panelH + 'px', 'important');
    if (stepped.layout === 'rail') {
      /* (2026-09-15, Justin's 1957px Chrome: "the bag is only showing half")
         The panel is the clip box, and the theme grid leaves it 720px wide
         at ~270..990 while the bag is centred on the usable band left of
         the 420px rail ((vw-420)/2 = 769): 500px of clip box on one side of
         the bag, 220px on the other, so on a tall window (taller band ->
         wider 1.8x image) the bag's right side fell outside it. Widen the
         clip box to the usable band with clip-path's negative insets
         instead of moving the panel: a transform on the panel would turn
         it into the containing block of the position:fixed rail buttons
         inside it (they jumped onto the bag when tried). Vertical clip
         edges stay the band edges (inset 0 top/bottom, as overflow:hidden
         gave); the horizontal ones now run from the viewport's left edge to
         8px short of the rail. overflow must be visible for the wider clip
         to show anything. */
      var railLeftLimit = 0;
      var railRightLimit = window.innerWidth - 420 - 8;
      var extL = Math.max(0, Math.round(panelRect.left - railLeftLimit));
      var extR = Math.max(0, Math.round(railRightLimit - panelRect.right));
      previewPanel.style.setProperty('overflow', 'visible', 'important');
      previewPanel.style.setProperty('clip-path', 'inset(0px ' + (-extR) + 'px 0px ' + (-extL) + 'px)', 'important');
    } else {
      previewPanel.style.setProperty('overflow', 'hidden', 'important');
      if (previewPanel.style.clipPath) previewPanel.style.removeProperty('clip-path'); /* rail leftover after a resize across the breakpoint */
    }
    canvas.style.setProperty('max-height', bandHeight + 'px', 'important');
    canvas.style.setProperty('object-fit', 'contain', 'important');
    canvas.style.setProperty('transform', 'scale(' + ZOOM + ')', 'important');
    canvas.style.setProperty('transform-origin', 'center center', 'important');
    /* No animated glide between corrections. */
    inner.style.setProperty('transition', 'none', 'important');
    var bandCenter = (bandTop + bandBottom) / 2;
    var canvasRect = canvas.getBoundingClientRect();
    var canvasCenter = canvasRect.top + canvasRect.height / 2;
    var canvasCenterX = canvasRect.left + canvasRect.width / 2;
    /* parse the currently-applied shift from the LIVE style (self-healing
       against KB digests). Accepts both the old translateY form and the
       combined translate(x, y) written below. */
    var appliedShift = 0, appliedShiftX = 0;
    var tf = inner.style.transform || '';
    var mY = /translateY\((-?\d+(?:\.\d+)?)px\)/.exec(tf);
    if (mY) appliedShift = parseFloat(mY[1]);
    var mXY = /translate\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\)/.exec(tf);
    if (mXY) { appliedShiftX = parseFloat(mXY[1]); appliedShift = parseFloat(mXY[2]); }
    /* (2026-09-15, evening) The canvas is what gets centred here — the BAG
       is centred inside the canvas by panCameraToBag() below, once, in the
       scene. An earlier version of this fix measured the bag's projected
       bounding box every heartbeat and slid the inner to match; the
       projection changes as the coach rotates the bag, so each beat nudged
       it a few px — "rotating the bag causes the bag to jump" (Justin).
       No per-beat measuring any more. */
    var naturalCenter = canvasCenter - appliedShift;
    var targetShift = Math.round(bandCenter - naturalCenter);
    var targetShiftX = 0;
    if (stepped.layout === 'rail') {
      /* center the bag in the space LEFT of the 420px rail (fixes the
         off-center bag + dead gulf Justin flagged 2026-09-01) */
      var usableCenterX = (window.innerWidth - 420) / 2;
      var naturalCenterX = canvasCenterX - appliedShiftX;
      targetShiftX = Math.round(usableCenterX - naturalCenterX);
    }
    if (Math.abs(targetShift - appliedShift) > 1 || Math.abs(targetShiftX - appliedShiftX) > 1) {
      inner.style.setProperty('transform', 'translate(' + targetShiftX + 'px, ' + targetShift + 'px)', 'important');
    }
  }

  /* World-space bounding box of KB's meshes (column-major matrixWorld
     applied by hand — no THREE global needed). Meshes larger than 5 units
     are skipped so a ground/shadow plane cannot swallow the box. Null until
     the model is in the scene. */
  function bagWorldBox(app) {
    try {
      if (!app || !app.lib || !app.lib.scene) return null;
      var min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity], any = false;
      app.lib.scene.traverse(function (o) {
        if (!o.isMesh || !o.geometry) return;
        if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
        var bb = o.geometry.boundingBox;
        if (!bb) return;
        if ((bb.max.x - bb.min.x) > 5 || (bb.max.y - bb.min.y) > 5 || (bb.max.z - bb.min.z) > 5) return;
        var m = o.matrixWorld.elements;
        for (var i = 0; i < 8; i++) {
          var x = (i & 1) ? bb.max.x : bb.min.x, y = (i & 2) ? bb.max.y : bb.min.y, z = (i & 4) ? bb.max.z : bb.min.z;
          var wx = m[0] * x + m[4] * y + m[8] * z + m[12];
          var wy = m[1] * x + m[5] * y + m[9] * z + m[13];
          var wz = m[2] * x + m[6] * y + m[10] * z + m[14];
          if (wx < min[0]) min[0] = wx; if (wx > max[0]) max[0] = wx;
          if (wy < min[1]) min[1] = wy; if (wy > max[1]) max[1] = wy;
          if (wz < min[2]) min[2] = wz; if (wz > max[2]) max[2] = wz;
          any = true;
        }
      });
      if (!any) return null;
      var sx = max[0] - min[0], sy = max[1] - min[1];
      /* bag-sized or it is not the bag yet (partial load, helper meshes) */
      if (!(sx > 0.05 && sx < 2 && sy > 0.05 && sy < 2)) return null;
      return { min: min, max: max };
    } catch (e) { return null; }
  }

  /* 3D CENTRING (2026-09-15, evening — "rotating the bag causes the bag to
     jump"). KB's OrbitControls pivot on (0, y, 0) while the model's bounding
     box is centred near (0.07, -0.02, 0.08), so the bag renders right of and
     below the canvas centre in every view, and any screen-space fix has to
     chase the projection as the bag turns. Fix it in the scene instead,
     once: pan camera AND target by the same vector (perspective unchanged)
     so the target sits on the bag's centre. From then on rotation, VIEW
     BACK (KB's setCamera copies a preset POSITION and keeps the target) and
     zoom all pivot on the bag, and the plain canvas-centring above is exact.
     Guarded to a target still at KB's (0, y, 0): a coach who right-drag
     pans owns the target after that; KB resetting it re-arms the pan. Rail
     (desktop) only — the sheet's zoom was tuned on Justin's phone with the
     bag where KB leaves it. */
  function panCameraToBag() {
    try {
      var app = window.__xeistPbrApp;
      if (!app || !app.lib || !app.lib.camera || !app.controls || !app.controls.target) return false;
      var t = app.controls.target;
      if (Math.abs(t.x) > 1e-6 || Math.abs(t.z) > 1e-6) return false;
      var box = bagWorldBox(app);
      if (!box) return false;
      var cx = (box.min[0] + box.max[0]) / 2, cy = (box.min[1] + box.max[1]) / 2, cz = (box.min[2] + box.max[2]) / 2;
      var dx = cx - t.x, dy = cy - t.y, dz = cz - t.z;
      if (Math.abs(dx) < 1e-4 && Math.abs(dy) < 1e-4 && Math.abs(dz) < 1e-4) return false;
      var cam = app.lib.camera;
      cam.position.x += dx; cam.position.y += dy; cam.position.z += dz;
      t.set(cx, cy, cz);
      app.controls.update();
      try { app.trackSceneChange(); } catch (e0) { /* noop */ }
      try { window.__xeistBagPan = { dx: +dx.toFixed(4), dy: +dy.toFixed(4), dz: +dz.toFixed(4), at: Date.now() }; } catch (e1) { /* noop */ }
      return true;
    } catch (e) { return false; }
  }

  /* Bag snapshot stash (2026-08-31, v2): parents must see the coach's
     ACTUAL bag on the parent-pay page. KB's WebGL runs
     preserveDrawingBuffer:false (verified live 2026-07-31, module 35), so
     a plain readback between frames is ALWAYS blank — the v1 stash never
     landed. This is module 35's proven capture, ported: read the canvas
     INSIDE a KB paint frame (temporary requestAnimationFrame wrap), nudge
     a redraw via synthetic resize, give up cleanly after 2.5s. Runs on
     step 0 only, throttled; result parked in window.__xeistBagSnapshot
     (module 38 uploads it; live capture there stays as fallback). */
  var lastSnapAttempt = 0;
  var snapInFlight = false;

  function readBagCanvasNow() {
    try {
      var best = null, bestArea = 0;
      var list = document.querySelectorAll('canvas');
      for (var i = 0; i < list.length; i++) {
        var a = (list[i].width || 0) * (list[i].height || 0);
        if (a > bestArea && list[i].width > 200 && list[i].height > 200) { best = list[i]; bestArea = a; }
      }
      if (!best) return null;
      var scale = Math.min(1, 1100 / Math.max(best.width, best.height));
      var w = Math.max(1, Math.round(best.width * scale));
      var h = Math.max(1, Math.round(best.height * scale));
      var oc = document.createElement('canvas');
      oc.width = w; oc.height = h;
      var ctx = oc.getContext('2d');
      /* parent-page hero background — always light there, never themed */
      ctx.fillStyle = '#f6f6f4';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(best, 0, 0, w, h);
      /* one pass: blank-check AND content bbox (crop tight to the bag) */
      var dd = ctx.getImageData(0, 0, w, h).data;
      var r0 = dd[0], g0 = dd[1], b0 = dd[2];
      var minX = w, minY = h, maxX = -1, maxY = -1;
      var step = 2;
      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          var di = (y * w + x) * 4;
          if (Math.abs(dd[di] - r0) + Math.abs(dd[di + 1] - g0) + Math.abs(dd[di + 2] - b0) > 28) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0 || (maxX - minX) < 40 || (maxY - minY) < 40) return null; /* blank / speck */
      var padX = Math.round((maxX - minX) * 0.10), padY = Math.round((maxY - minY) * 0.08);
      var cx = Math.max(0, minX - padX), cy = Math.max(0, minY - padY);
      var cw = Math.min(w - cx, (maxX - minX) + padX * 2);
      var ch = Math.min(h - cy, (maxY - minY) + padY * 2);
      var out = document.createElement('canvas');
      var outScale = Math.min(1, 900 / Math.max(cw, ch));
      out.width = Math.max(1, Math.round(cw * outScale));
      out.height = Math.max(1, Math.round(ch * outScale));
      var octx = out.getContext('2d');
      octx.fillStyle = '#f6f6f4';
      octx.fillRect(0, 0, out.width, out.height);
      octx.drawImage(oc, cx, cy, cw, ch, 0, 0, out.width, out.height);
      var url = out.toDataURL('image/jpeg', 0.85);
      return url.length < 600 * 1024 ? url : null;
    } catch (e) { return null; }
  }

  function captureBagDesign(done) {
    var now = readBagCanvasNow();
    if (now) { done(now); return; }
    var raf = window.requestAnimationFrame;
    if (!raf) { done(null); return; }
    var finished = false;
    function finish(url) {
      if (finished) return;
      finished = true;
      window.requestAnimationFrame = raf;
      done(url);
    }
    var attempts = 0;
    window.requestAnimationFrame = function (cb) {
      return raf.call(window, function (ts) {
        try { cb(ts); } catch (e) { /* noop */ }
        if (!finished && attempts < 8) { /* frame-capped: a readback scans the whole canvas — never let it ride every frame */
          attempts++;
          var u = readBagCanvasNow(); /* buffer still valid within this frame */
          if (u) finish(u);
          else if (attempts >= 8) finish(null);
        }
      });
    };
    try {
      window.dispatchEvent(new Event('resize'));
      var sync = readBagCanvasNow();
      if (sync) { finish(sync); return; }
    } catch (e) { /* noop */ }
    setTimeout(function () { finish(null); }, 2500);
  }

  /* DECORATION SIGNATURE + SETTLED CAPTURE (2026-09-17, Justin: "too often
     it's not capturing the front logo in the screen grab even though I put
     the logo on the bag"). The old stash was taken on step 0 and then
     trusted for 30s. But the logo lands in stages: the upload is placed
     (the wall closes, hasLogo is true) — its texture draws a few frames
     later — then module 21 clicks Remove Background ~2s on and KitBuilder
     swaps the image again, blank for a moment in between. A capture in
     any of those gaps was kept for half a minute, which is exactly how
     long a coach takes to reach the parent link.
     Now: every stash carries the design's decoration signature (the
     logo/number items' identity, image, text, geometry). A signature
     change — logo landed, background removed, number typed, decoration
     moved — starts a capture BURST that keeps capturing (~every 900ms,
     up to 10 tries) until two consecutive frames are pixel-identical and
     differ from the frame before the change; each try replaces the stash
     at once (latest wins), the last one marks it settled. A stash whose
     signature is not the design's is never trusted: module 38 asks
     __xeistBagCapture.fresh() before it shows or uploads anything. Bursts
     run on steps 0-2 (the bag is on screen behind the rail / sheet) but
     never while submitting or syncing (the 2026-09-01 freeze). */
  function strHash(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  var SIG_KEYS = ['id', 'image', 'src', 'value', 'url', 'imageId', 'file', 'text', 'placementKey', 'x', 'y', 'left', 'top', 'scale', 'width', 'height', 'rotation', 'angle', 'size'];
  function itemSig(it) {
    if (!it || typeof it !== 'object') return '';
    var parts = [];
    for (var i = 0; i < SIG_KEYS.length; i++) {
      var v = it[SIG_KEYS[i]];
      if (v == null || typeof v === 'object' || typeof v === 'function') continue;
      v = String(v);
      parts.push(SIG_KEYS[i] + '=' + (v.length > 48 ? strHash(v) + ':' + v.length : v));
    }
    return parts.join('|');
  }
  function decoSig() {
    try {
      var b = window.XeistKBBridge;
      if (!b) return '';
      var L = (typeof b.hasLogo === 'function') ? b.hasLogo() : null;
      var N = (typeof b.hasNumber === 'function') ? b.hasNumber() : null;
      return 'L:' + itemSig(L && L.item) + ';N:' + itemSig(N && N.item);
    } catch (e) { return ''; }
  }
  var burst = null; /* { sig, tries, last, prevUrl, timer, waiters } */
  function stashIsCurrent() {
    var st = window.__xeistBagSnapshot;
    return !!(st && st.dataUrl && st.settled && st.sig === decoSig());
  }
  function finishBurst() {
    if (!burst) return;
    var w = burst.waiters; burst = null;
    var st = window.__xeistBagSnapshot || null;
    for (var i = 0; i < w.length; i++) { try { w[i](st); } catch (e) { /* noop */ } }
  }
  function burstTick() {
    if (!burst) return;
    if (state.isSubmitting || state.isSyncing || stepped.step > 2) { burst.timer = setTimeout(burstTick, 900); return; }
    var sigNow = decoSig();
    if (sigNow !== burst.sig) { burst.sig = sigNow; burst.tries = 0; burst.last = null; } /* changed again mid-burst: start over */
    burst.tries++;
    snapInFlight = true;
    lastSnapAttempt = Date.now();
    captureBagDesign(function (url) {
      snapInFlight = false;
      if (!burst) return;
      if (url) {
        var settled = !!burst.last && url === burst.last && url !== burst.prevUrl;
        window.__xeistBagSnapshot = { dataUrl: url, ts: Date.now(), sig: burst.sig, settled: settled };
        burst.last = url;
        if (settled) { finishBurst(); return; }
      }
      if (burst.tries >= 10) {
        /* never settled (idle rotation, or the canvas is covered): keep the
           latest frame and stop asking */
        var st = window.__xeistBagSnapshot;
        if (st && st.sig === burst.sig) st.settled = true;
        finishBurst();
        return;
      }
      burst.timer = setTimeout(burstTick, 900);
    });
  }
  function startBurst(sig) {
    var st = window.__xeistBagSnapshot;
    if (burst) { if (burst.sig !== sig) { burst.sig = sig; burst.tries = 0; burst.last = null; } return; }
    burst = { sig: sig, tries: 0, last: null, prevUrl: (st && st.dataUrl) || null, timer: null, waiters: [] };
    burstTick();
  }

  function captureBagSnapshot() {
    /* Heartbeat entry (renderStepped, every 800ms + on customization
       events): start a burst when the stash is missing or stale for the
       design; do nothing while one is settled. */
    if (burst || snapInFlight || state.isSubmitting || state.isSyncing || stepped.step > 2) return;
    if (stashIsCurrent()) return;
    var sig = decoSig();
    var st = window.__xeistBagSnapshot;
    /* A stash for THIS signature that failed to settle keeps a 20s rest
       between bursts (idle-rotating models never settle). */
    if (st && st.sig === sig && Date.now() - st.ts < 20000) return;
    startBurst(sig);
  }

  /* Module 38 (the share popup) asks for a frame it can trust: settled
     for the design as it is now, else a burst runs and the callback fires
     with the best frame when it settles (or after the cap). */
  window.__xeistBagCapture = {
    sig: decoSig,
    current: stashIsCurrent,
    fresh: function (cb) {
      try {
        if (stashIsCurrent()) { cb(window.__xeistBagSnapshot); return; }
        if (state.isSubmitting || state.isSyncing) { cb(window.__xeistBagSnapshot || null); return; }
        startBurst(decoSig());
        if (burst) burst.waiters.push(cb); else cb(window.__xeistBagSnapshot || null);
      } catch (e) { try { cb(window.__xeistBagSnapshot || null); } catch (e2) { /* noop */ } }
    }
  };

  /* Chat-launcher bump (2026-09-01, Justin): the store's chat widget parks
     bottom-right and overlaps the mini bar / CTA in stepped mode. Provider-
     agnostic: find any SMALL FIXED element parked in the bottom-right
     corner (chat launchers are direct-ish body children, ~40-120px square)
     and lift it above the mini bar (sheet) / left of the rail (desktop).
     Re-applied every few seconds — widgets load late and re-render. */
  var chatBumpLast = 0;
  function bumpChatWidget() {
    var now = Date.now();
    if (now - chatBumpLast < 3000) return;
    chatBumpLast = now;
    try {
      var cands = document.querySelectorAll('body > *, body > * > *');
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        if (!el || !el.getBoundingClientRect) continue;
        if (el.closest && (el.closest('[data-xeist-flow-shell]') || el.closest('#xeist-bottom-bar'))) continue;
        if (/^(script|style|link)$/i.test(el.tagName)) continue;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed') continue;
        var r = el.getBoundingClientRect();
        if (r.width < 36 || r.width > 120 || r.height < 36 || r.height > 120) continue;
        if (window.innerHeight - r.bottom > 48) continue; /* parked at the bottom edge */
        if (window.innerWidth - r.right > 48) continue;   /* parked at the right edge */
        if (stepped.layout === 'rail') {
          el.style.setProperty('right', '444px', 'important');
        } else {
          /* clear the mini bar: bar ~128px + safe area + breathing room */
          el.style.setProperty('bottom', '152px', 'important');
        }
      }
    } catch (e) { /* noop */ }
  }

  function renderStepped() {
    if (!stepped.active || !stepped.els) return;
    var els2 = stepped.els;
    var summary = getSummary();
    var belowMin = summary.quantity < minQty;

    /* mini bar (step 0) */
    if (els2.minibarSub) {
      els2.minibarSub.textContent = formatMoney(summary.unitPrice) + ' each \u00b7 logo & number included \u00b7 ' + minQty + ' ' + NOUN + ' min';
    }
    if (els2.productName && config.orderTitle) els2.productName.textContent = String(config.orderTitle).replace(/ Order$/, '');
    if (els2.railName && config.orderTitle) els2.railName.textContent = String(config.orderTitle).replace(/ Order$/, '');
    if (els2.railSub) {
      els2.railSub.textContent = formatMoney(summary.unitPrice) + ' each \u00b7 logo & number included \u00b7 ' + minQty + ' ' + NOUN + ' min';
    }

    /* quantity step */
    if (els2.qtyInput && document.activeElement !== els2.qtyInput) {
      els2.qtyInput.value = String(summary.quantity);
    }
    if (els2.qtyDown) els2.qtyDown.disabled = summary.quantity <= minQty;
    if (els2.qtyUp) els2.qtyUp.disabled = summary.quantity >= maxQty;
    steppedPriceFocus(summary);
    if (els2.continueQty) els2.continueQty.disabled = belowMin;
    if (els2.underQty) {
      if (belowMin) {
        els2.underQty.textContent = minQty + ' ' + NOUN + ' minimum \u2014 add ' + (minQty - summary.quantity) + ' more to continue.';
        els2.underQty.hidden = false;
      } else {
        els2.underQty.hidden = true;
      }
    }

    /* payment step */
    var da = steppedDepositAmounts(summary);
    if (els2.payFullSub) els2.payFullSub.textContent = formatMoney(summary.subtotal) + ' today\nNothing owed later';
    if (els2.payDepName) els2.payDepName.textContent = da.pct + '% deposit';
    if (els2.payDepSub) els2.payDepSub.textContent = formatMoney(da.dep) + ' today\n' + formatMoney(da.rem) + ' due before shipping';
    if (els2.payFull) {
      els2.payFull.classList.toggle('is-sel', stepped.pay === 'full');
      els2.payFull.setAttribute('aria-checked', stepped.pay === 'full' ? 'true' : 'false');
    }
    if (els2.payDep) {
      els2.payDep.classList.toggle('is-sel', stepped.pay === 'dep');
      els2.payDep.setAttribute('aria-checked', stepped.pay === 'dep' ? 'true' : 'false');
    }
    /* Parents pay: first-class always-on card (Changes 7/8 ruling —
       full always-on card only once the worker can actually charge
       parents). Requires module 38 on the page. */
    var parAvailable = !!window.__xeistBagPay;
    /* What a parent is actually charged (2026-09-06): once module 38 is
       armed, the parent page charges a fixed-CAD authority price, not the
       coach's FX-floating tier price — so the card must quote THAT number.
       Unarmed (collect-only) keeps the coach unit price as the estimate. */
    var parUnit = summary.unitPrice;
    try {
      var pc = window.__xeistBagPay && typeof window.__xeistBagPay.parentUnitCents === 'function'
        ? window.__xeistBagPay.parentUnitCents(summary.quantity) : null;
      if (pc != null) parUnit = pc / 100;
    } catch (ePar) { /* estimate stays */ }
    if (els2.payPar) {
      els2.payPar.hidden = !parAvailable;
      els2.payPar.classList.toggle('is-sel', stepped.pay === 'par');
      els2.payPar.setAttribute('aria-checked', stepped.pay === 'par' ? 'true' : 'false');
    }
    if (els2.payParSub) els2.payParSub.textContent = 'You pay $0 today\nEach parent pays ' + formatMoney(parUnit);
    if (els2.continuePay) els2.continuePay.disabled = !stepped.pay;
    /* Parents pay (2026-09-16, Justin: the Review sheet "isn't needed" in
       this mode): Payment's Continue IS the parent-link action. Choosing
       the card and tapping it opens module 38 (phone number -> link +
       price per parent); the coach never sees Review. Label mirrors the
       old Review CTA so a link already made reads "View parent link". */
    var parMode = stepped.pay === 'par';
    if (els2.continuePay) {
      els2.continuePay.textContent = parMode
        ? ((window.__xeistBagPay && window.__xeistBagPay.hasLink()) ? 'View parent link' : 'Create parent link')
        : 'Continue';
    }
    if (els2.ticks && els2.ticks.length > 3) els2.ticks[3].hidden = parMode;

    /* review step */
    var hasLogo = hasLogoSelectionLocal();
    var hasNum = hasNumberSelection();
    var deco = hasLogo && hasNum ? 'Logo + numbers' : hasLogo ? 'Logo' : hasNum ? 'Numbers' : 'None';
    if (els2.revDeco) els2.revDeco.textContent = deco;
    if (els2.revDecoSub) els2.revDecoSub.textContent = 'Decoration: ' + deco.toLowerCase();
    if (els2.revName && config.orderTitle) els2.revName.textContent = String(config.orderTitle).replace(/ Order$/, '');
    if (els2.revQty) els2.revQty.textContent = summary.quantity + ' ' + nounFor(summary.quantity);
    /* Parents pay: every figure on Review is what a PARENT is charged
       (fixed CAD authority price x team size) - never the coach's
       FX-floating tier price. The 2026-09-06 live walk showed "Price
       $61.75 each" and "Order total $741.00" beside "Parent price $59.99
       each" on the same screen. */
    var isPar = stepped.pay === 'par';
    if (els2.revEach) els2.revEach.textContent = formatMoney(isPar ? parUnit : summary.unitPrice) + ' each';
    if (els2.revPay) els2.revPay.textContent = stepped.pay === 'dep' ? da.pct + '% deposit' : stepped.pay === 'full' ? 'Pay in full' : stepped.pay === 'par' ? 'Parents pay' : '\u2014';
    var due = stepped.pay === 'dep' ? da.dep : summary.subtotal;
    if (els2.mTotal) els2.mTotal.textContent = formatMoney(isPar ? parUnit * summary.quantity : summary.subtotal);
    if (stepped.pay === 'par') {
      if (els2.mDueK) els2.mDueK.textContent = 'You pay today';
      if (els2.mDue) els2.mDue.textContent = '$0';
      if (els2.mRemK) els2.mRemK.textContent = 'Parent price';
      if (els2.mRemRow) els2.mRemRow.hidden = false;
      if (els2.mRem) els2.mRem.textContent = formatMoney(parUnit) + ' each';
    } else {
      if (els2.mDueK) els2.mDueK.textContent = 'Due today';
      if (els2.mDue) els2.mDue.textContent = formatMoney(due);
      if (els2.mRemK) els2.mRemK.textContent = 'Due before shipping';
      if (els2.mRemRow) els2.mRemRow.hidden = stepped.pay !== 'dep';
      if (els2.mRem) els2.mRem.textContent = formatMoney(da.rem);
    }
    if (els2.checkout) {
      var ckLabel = '';
      var ckAmt = '';
      if (stepped.pay === 'par') {
        els2.checkout.disabled = !window.__xeistBagPay;
        ckLabel = (window.__xeistBagPay && window.__xeistBagPay.hasLink())
          ? 'View parent link'
          : 'Create parent link';
      } else {
        els2.checkout.disabled = !state.bridgeReady || state.isSubmitting || belowMin || !stepped.pay;
        ckLabel = state.isSubmitting
          ? 'Adding\u2026'
          : !state.bridgeReady
            ? 'Preparing your customizer\u2026'
            : 'Continue to Checkout';
        if (!state.isSubmitting && state.bridgeReady && !belowMin && stepped.pay) ckAmt = formatMoney(due) + ' due today';
      }
      if (els2.checkoutLabel) {
        els2.checkoutLabel.textContent = ckLabel;
        if (els2.checkoutAmt) {
          els2.checkoutAmt.textContent = ckAmt;
          els2.checkoutAmt.hidden = !ckAmt;
        }
      } else {
        els2.checkout.textContent = ckAmt ? ckLabel + ' \u2014 ' + ckAmt : ckLabel;
      }
    }
    if (els2.checkoutUnder) {
      els2.checkoutUnder.textContent = stepped.pay === 'par'
        ? 'You pay $0 today. Parents enter their player\u2019s name and number when they pay.'
        : 'We\u2019ll collect player information after checkout.';
    }

    /* Phase C: mirror decoration state onto the module 16/17 tool buttons
       so the flow css can show the added ring (their own inline styles are
       overridden with !important in stepped mode). */
    try {
      var logoBtn = document.getElementById('xeist-add-logo-overlay');
      if (logoBtn) { if (hasLogo) logoBtn.setAttribute('data-xf-on', '1'); else logoBtn.removeAttribute('data-xf-on'); }
      var numBtn = document.getElementById('xeist-add-number-overlay');
      if (numBtn) { if (hasNum) numBtn.setAttribute('data-xf-on', '1'); else numBtn.removeAttribute('data-xf-on'); }
    } catch (e) { /* noop */ }

    /* ticks */
    if (els2.ticks) {
      for (var t = 0; t < els2.ticks.length; t++) {
        els2.ticks[t].classList.toggle('is-cur', t === stepped.step);
        els2.ticks[t].classList.toggle('is-done', t < stepped.step);
      }
    }

    /* decorated-bag thumbs on Quantity/Payment/Review (2026-09-01) */
    try {
      var snap = window.__xeistBagSnapshot;
      if (els2.thumbs) {
        for (var th = 0; th < els2.thumbs.length; th++) {
          var im = els2.thumbs[th];
          if (snap && snap.dataUrl) {
            if (im.getAttribute('data-snap-ts') !== String(snap.ts)) {
              im.src = snap.dataUrl;
              im.setAttribute('data-snap-ts', String(snap.ts));
            }
            im.hidden = false;
          } else {
            im.hidden = true;
          }
        }
      }
    } catch (e) { /* noop */ }

    if (stepped.layout === 'rail') { try { panCameraToBag(); } catch (e) { /* noop */ } }
    try { steppedCenterBag(); } catch (e) { /* noop */ }
    try { captureBagSnapshot(); } catch (e) { /* noop */ }
    try { bumpChatWidget(); } catch (e) { /* noop */ }
  }

  function steppedGo(n) {
    stepped.step = Math.max(0, Math.min(3, toInt(n, 0)));
    /* step stamp: flow css hides the customize-only overlays (logo/number
       tools, save/share, resize cluster) on steps 1-3 — they are fixed at
       z 99001, above the panels, and floated over every screen otherwise. */
    document.documentElement.setAttribute('data-xeist-step', String(stepped.step));
    if (stepped.step === 2) steppedTrack('payment_viewed', null, true);
    if (stepped.step === 3) steppedTrack('review_viewed', null, true);
    var els2 = stepped.els;
    if (!els2) return;
    var rail = stepped.layout === 'rail';
    var onPanels = rail || stepped.step > 0;
    if (els2.minibar) els2.minibar.hidden = rail || stepped.step > 0;
    if (els2.panels) els2.panels.hidden = !onPanels;
    if (els2.back) els2.back.style.visibility = stepped.step === 0 ? 'hidden' : 'visible';
    for (var i = 0; i < els2.steps.length; i++) {
      var idx = toInt(els2.steps[i].getAttribute('data-xf-step'), -1);
      els2.steps[i].classList.toggle('is-on', idx === stepped.step);
      els2.steps[i].hidden = idx !== stepped.step;
    }
    steppedPersist();
    renderStepped();
  }

  function steppedQtyDelta(delta) {
    var current = clampQty(state.quantity, minQty);
    stepped.prevUnitUsd = getTierForQuantity(current).unitPrice;
    var next = delta < 0 ? Math.max(minQty, current + delta) : Math.min(maxQty, current + delta);
    handleQuantityChange(next);
    stepped.lastQtyMethod = 'stepper';
    var nowUnit = getTierForQuantity(clampQty(state.quantity, minQty)).unitPrice;
    stepped.flashDown = nowUnit > stepped.prevUnitUsd;
    if (nowUnit < stepped.prevUnitUsd) steppedTrack('tier_up', { qty: state.quantity }, true);
    if (stepped.flashDown) steppedTrack('tier_down', { qty: state.quantity }, true);
    steppedPersist();
    renderStepped();
  }

  function steppedMount() {
    var shell = document.querySelector('[data-xeist-flow-shell]');
    if (!shell) return;
    var q = function (sel) { return shell.querySelector(sel); };
    stepped.els = {
      shell: shell,
      minibar: q('[data-xf-minibar]'),
      minibarSub: q('[data-xf-minibar-sub]'),
      productName: q('[data-xf-product-name]'),
      panels: q('[data-xf-panels]'),
      steps: shell.querySelectorAll('[data-xf-step]'),
      back: q('[data-xf-back]'),
      ticks: shell.querySelectorAll('[data-xf-tick]'),
      continue0: q('[data-xf-continue]'),
      continueRail: q('[data-xf-continue-rail]'),
      railName: q('[data-xf-rail-name]'),
      railSub: q('[data-xf-rail-sub]'),
      qtyDown: q('[data-xf-qty-down]'),
      qtyUp: q('[data-xf-qty-up]'),
      qtyInput: q('[data-xf-qty-input]'),
      each: q('[data-xf-each]'),
      eachAmt: q('[data-xf-each-amt]'),
      eachUnit: q('[data-xf-each-unit]'),
      next: q('[data-xf-next]'),
      nextLine: q('[data-xf-next-line]'),
      nextSave: q('[data-xf-next-save]'),
      nextBar: q('[data-xf-next-bar]'),
      nextFill: q('[data-xf-next-fill]'),
      continueQty: q('[data-xf-continue-qty]'),
      underQty: q('[data-xf-under-qty]'),
      payFull: q('[data-xf-pay-full]'),
      payDep: q('[data-xf-pay-dep]'),
      payPar: q('[data-xf-pay-par]'),
      payFullSub: q('[data-xf-pay-full-sub]'),
      payDepName: q('[data-xf-pay-dep-name]'),
      payDepSub: q('[data-xf-pay-dep-sub]'),
      payParSub: q('[data-xf-pay-par-sub]'),
      continuePay: q('[data-xf-continue-pay]'),
      mDueK: q('[data-xf-m-due-k]'),
      mRemK: q('[data-xf-m-rem-k]'),
      revName: q('[data-xf-rev-name]'),
      revDecoSub: q('[data-xf-rev-deco-sub]'),
      revDeco: q('[data-xf-rev-deco]'),
      revQty: q('[data-xf-rev-qty]'),
      revEach: q('[data-xf-rev-each]'),
      revPay: q('[data-xf-rev-pay]'),
      mTotal: q('[data-xf-m-total]'),
      mDue: q('[data-xf-m-due]'),
      mRemRow: q('[data-xf-m-rem-row]'),
      mRem: q('[data-xf-m-rem]'),
      checkout: q('[data-xf-checkout]'),
      checkoutLabel: q('[data-xf-checkout-label]'),
      checkoutAmt: q('[data-xf-checkout-amt]'),
      checkoutUnder: q('[data-xf-checkout-under]'),
      editRows: shell.querySelectorAll('[data-xf-edit]'),
      thumbs: shell.querySelectorAll('[data-xf-thumb]')
    };
    var els2 = stepped.els;

    steppedRestore();
    /* No preselection: until the coach chooses in THIS flow, no stale
       deposit preference may ride into the cart flag. */
    if (stepped.pay === null) {
      state.depositSelected = false;
    } else {
      state.depositSelected = stepped.pay === 'dep';
    }

    var decoScrim = document.querySelector('[data-xf-deco-scrim]');
    function hideDecoSheet() {
      if (!decoScrim) return;
      decoScrim.classList.remove('is-on');
      window.setTimeout(function () { decoScrim.hidden = true; }, 260);
    }
    function onContinue0() {
      steppedTrack('customize_continue', { logo: hasLogoSelectionLocal(), number: hasNumberSelection() }, true);
      if (decoScrim && !stepped.decoShown && !hasLogoSelectionLocal() && !hasNumberSelection()) {
        stepped.decoShown = true;
        steppedPersist();
        decoScrim.hidden = false;
        window.setTimeout(function () { decoScrim.classList.add('is-on'); }, 20);
        return;
      }
      steppedGo(1);
    }
    if (els2.continueRail) els2.continueRail.addEventListener('click', onContinue0);
    if (els2.continue0) els2.continue0.addEventListener('click', function () {
      steppedTrack('customize_continue', { logo: hasLogoSelectionLocal(), number: hasNumberSelection() }, true);
      if (decoScrim && !stepped.decoShown && !hasLogoSelectionLocal() && !hasNumberSelection()) {
        stepped.decoShown = true;
        steppedPersist();
        decoScrim.hidden = false;
        /* next frame so the transition runs */
        window.setTimeout(function () { decoScrim.classList.add('is-on'); }, 20);
        return;
      }
      steppedGo(1);
    });
    if (decoScrim) {
      var decoAdd = decoScrim.querySelector('[data-xf-deco-add]');
      var decoSkip = decoScrim.querySelector('[data-xf-deco-skip]');
      if (decoAdd) decoAdd.addEventListener('click', function () {
        hideDecoSheet();
        try {
          var lb = document.getElementById('xeist-add-logo-overlay');
          if (lb) lb.click();
        } catch (e) { /* noop */ }
      });
      if (decoSkip) decoSkip.addEventListener('click', function () {
        hideDecoSheet();
        steppedGo(1);
      });
      decoScrim.addEventListener('click', function (event) {
        if (event.target === decoScrim) hideDecoSheet();
      });
    }
    if (els2.continueQty) els2.continueQty.addEventListener('click', function () {
      if (els2.continueQty.disabled) return;
      steppedTrack('quantity_continue', { qty: state.quantity, method: stepped.lastQtyMethod || 'default' });
      steppedGo(2);
    });
    if (els2.continuePay) els2.continuePay.addEventListener('click', function () {
      if (!stepped.pay) return;
      if (stepped.pay === 'par') {
        /* Module 38's popup straight from Payment (2026-09-16): phone
           number -> "Send this to parents" (link, price per parent, paid
           status). Review is skipped in par mode — the coach's job ends
           when the link is sent; closing the popup lands back here with
           the CTA reading "View parent link". */
        steppedTrack('parent_link_opened', { qty: state.quantity, from: 'payment' });
        if (window.__xeistBagPay) window.__xeistBagPay.open();
        renderStepped();
        return;
      }
      steppedTrack('payment_continue', { method: stepped.pay });
      steppedGo(3);
    });
    if (els2.checkout) els2.checkout.addEventListener('click', function () {
      if (els2.checkout.disabled) return;
      if (stepped.pay === 'par') {
        /* Module 38's popup (2026-09-16 copy cut): phone number ->
           "Get parent link", then "Send this to parents" (share sheet /
           Copy) + paid status. It floats at z 100002, above the panels —
           the coach lands back on Review when they close it. */
        steppedTrack('parent_link_opened', { qty: state.quantity });
        if (window.__xeistBagPay) window.__xeistBagPay.open();
        renderStepped();
        return;
      }
      steppedTrack('checkout_clicked', { method: stepped.pay, qty: state.quantity });
      handleSubmit();
      renderStepped();
    });
    if (els2.back) els2.back.addEventListener('click', function () { steppedGo(stepped.step - 1); });
    for (var t = 0; t < els2.ticks.length; t++) {
      (function (idx) {
        els2.ticks[idx].addEventListener('click', function () {
          if (idx < stepped.step) steppedGo(idx);
        });
      })(t);
    }
    if (els2.qtyDown) els2.qtyDown.addEventListener('click', function () { steppedQtyDelta(-1); });
    if (els2.qtyUp) els2.qtyUp.addEventListener('click', function () { steppedQtyDelta(1); });
    if (els2.qtyInput) {
      els2.qtyInput.addEventListener('input', function (event) {
        var raw = String(event.target.value || '').trim();
        var parsed = toInt(raw, NaN);
        if (raw === '' || !isFinite(parsed)) return;
        stepped.prevUnitUsd = getTierForQuantity(clampQty(state.quantity, minQty)).unitPrice;
        state.quantity = Math.min(maxQty, Math.max(1, parsed));
        state.hasUnsyncedChanges = true;
        state.syncError = null;
        scheduleSync(250);
        stepped.lastQtyMethod = 'typed';
        var nowUnit2 = getTierForQuantity(clampQty(state.quantity, minQty)).unitPrice;
        stepped.flashDown = nowUnit2 > stepped.prevUnitUsd;
        if (nowUnit2 < stepped.prevUnitUsd) steppedTrack('tier_up', { qty: state.quantity }, true);
        if (stepped.flashDown) steppedTrack('tier_down', { qty: state.quantity }, true);
        renderStepped();
      });
      els2.qtyInput.addEventListener('blur', function (event) {
        handleQuantityChange(event.target.value);
        steppedPersist();
        renderStepped();
      });
      els2.qtyInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); event.target.blur(); }
      });
    }
    function choosePay(mode) {
      stepped.pay = mode;
      steppedTrack('payment_selected', { method: mode });
      state.depositSelected = mode === 'dep'; /* 'par' clears it — no Downpay flag can ride */
      try { lsSet(DEPOSIT_PREF_KEY, state.depositSelected ? '1' : '0'); } catch (e) { /* noop */ }
      /* keep the hidden bar radios coherent for anything else that reads them */
      try {
        if (els.payModeFull) els.payModeFull.checked = mode === 'full';
        if (els.payModeDeposit) els.payModeDeposit.checked = mode === 'dep';
      } catch (e) { /* noop */ }
      steppedPersist();
      renderStepped();
    }
    if (els2.payFull) els2.payFull.addEventListener('click', function () { choosePay('full'); });
    if (els2.payDep) els2.payDep.addEventListener('click', function () { choosePay('dep'); });
    if (els2.payPar) els2.payPar.addEventListener('click', function () { choosePay('par'); });
    /* Module 38 announces link creation / popup close; re-render so the
       Payment CTA flips to "View parent link" without a step change. */
    try { window.addEventListener('xeist:bagpay', function () { renderStepped(); }); } catch (eBp) { /* noop */ }
    for (var r = 0; r < els2.editRows.length; r++) {
      (function (row) {
        row.addEventListener('click', function () {
          steppedTrack('review_edit_clicked', { to: toInt(row.getAttribute('data-xf-edit'), 0) });
          steppedGo(toInt(row.getAttribute('data-xf-edit'), 0));
        });
      })(els2.editRows[r]);
    }

    stepped.active = true;
    shell.hidden = false;
    document.documentElement.setAttribute('data-xeist-flow', 'on');
    document.documentElement.setAttribute('data-xeist-flow-layout', stepped.layout);
    steppedGo(stepped.step);
    /* Heartbeat: pick up bridge hydration, FX arrival, decoration changes.
       Same cadence as the panel's own passive re-render. */
    stepped.interval = window.setInterval(renderStepped, 800);
    window.addEventListener('xeist:customization-changed', renderStepped);
    /* a logo landing / number change asks for a fresh frame straight away */
    window.addEventListener('xeist:customization-changed', function () { try { captureBagSnapshot(); } catch (e) { /* noop */ } });
  }

  (function steppedFlowScaffold() {
    try {
      var layout = steppedFlowActive();
      if (!layout) return;
      stepped.layout = layout;
      steppedMount();
    } catch (e) { /* never break the panel */ }
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setupSizeStep();
})();
